export default {
  common: { loading: 'Laddar…', noData: 'Inga data', clear: 'Rensa', delete: 'Radera' },
  errors: { /* notices-i18n */
    generic: 'Något gick fel. Försök igen.',    codes: {
      // The clock card's refusals (time-api /timer/start and /timer/stop): the card
      // shows the specific reason, as time-ui's own clock button does (issue 700).
      leave_day: 'Den här dagen har en godkänd heldagsfrånvaro — ingen arbetstid kan registreras på den.',
      // A person her contract frees from booking working time (issue 981): time-api refuses the clock-in with this code.
      work_time_booking_off: 'Enligt ditt avtal bokar du bara projekttid, inte arbetstid.',
      week_approved: 'Den här veckan är redan godkänd och låst – ändringar bara via en korrigeringsbegäran.',
      week_submitted: 'Den här veckan är inskickad och väntar på beslut – ändringar först när den har dragits tillbaka eller skickats tillbaka.',
      already_clocked_in: 'Du är redan instämplad. Avsluta den pågående arbetstiden först.',
      block_overlap: 'Den här arbetstiden överlappar en annan.',
      block_locked: 'Den här arbetstiden är låst av en godkänd vecka. Begär en korrigering i stället.',
      // user-api's SSO connection PUT (#882): issuer and client are frozen while SSO is enforced.
      sso_enforced: 'Stäng av ”Kräv inloggning endast via SSO” innan du ändrar utfärdar-URL:en eller Client ID.',
      // The SSO connection PUT of user-api (issue 926): a list entry that is not a domain.
      invalid_domain: 'En av e-postdomänerna är ingen domän. Ange domäner som example.com, utan jokertecken eller webbadresser.',
      // ats-api reports this flat on the envelope; `errorKeyFor` prefers a
      // curated code entry over the status fallback, which is how the custom-field
      // dialog keeps its one specific message without reading the backend string.
      CUSTOM_FIELD_SENSITIVITY_LOCKED: 'Fältet är deklarerat som känsliga uppgifter och deklarationen kan inte tas tillbaka.',
      LEGAL_NOTICE_BLANK_EMPTY: 'Ett fält kan inte fyllas i med ingenting.',
      LEGAL_NOTICE_BLANK_UNKNOWN: 'Denna text har inget fält med det namnet.',
      LEGAL_NOTICE_BLANK_TOKEN: 'Ett värde får inte självt innehålla ett öppet fält.',
      // The employee-notice gate (issue 576 M3): the invite refusal names WHO
      // can clear it, so an admin sent here knows the fix is not theirs to retry.
      EMPLOYEE_NOTICE_INCOMPLETE: 'Inbjudningar är pausade tills alla fält i meddelandena för anställda under Juridisk information är ifyllda. Be arbetsytans ägare, en suite-administratör eller dataskyddsombudet att fylla i dem.',
      LEGAL_READINESS_UNAVAILABLE: 'Vi kunde inte kontrollera om meddelandena för anställda är kompletta. Försök igen om några minuter.',
    } as Record<string, string>,
  },
  billing: {
    title: 'Fakturering', status: 'Status', paymentMethod: 'Betalningsmetod',
    updateCard: 'Byt ut kort', addCard: 'Lägg till kort',
    invoices: 'Fakturor', charges: 'Betalningar',
    noInvoices: 'Inga fakturor ännu.', noCharges: 'Inga betalningar ännu.',
    noCard: 'Inget registrerat', validUntil: 'giltigt till {date}',
    trialDaysLeft: '{days} dagar kvar av testperioden', trialExpired: 'Testperioden har löpt ut',
    trialDaysLeftUntil: '{days} dagar kvar av testperioden — slutar {date}',
    // A free_months promo account (issue 808): the whole cardless run, never "trial end" at d2.
    trialDaysLeftFree: '{days} dagar kvar utan kostnad — till {date}',
    nextChargeOn: 'Nästa debitering den {date}',
    exempt: { badge: 'Undantagen från fakturering', note: 'lumi har kommit överens om att den här arbetsytan inte faktureras just nu.' },
    download: 'Ladda ner', dangerZone: 'Riskzon',
    col: { date: 'Datum', period: 'Period', net: 'Netto', vat: 'moms', gross: 'Brutto', status: 'Status', kind: 'Typ', amount: 'Belopp', document: 'Faktura' },
    statusLabel: { trialing: 'Testperiod', active: 'Aktiv', delinquent: 'Betalning krävs', closed: 'Avslutad', canceled: 'Uppsagd' },
    tab: { plans: 'Planer', paymentMethod: 'Betalningsmetod', invoices: 'Fakturor och betalningar', referral: 'Värvning', externalPostings: 'Platsannonser', dangerZone: 'Säg upp och radera' },
    externalPostings: {
      title: 'Annonser på externa jobbsajter',
      intro: 'Annonser på externa jobbsajter beställs en och en och faktureras per beställning — upp till flera tusen euro styck. När det här är på kan alla vars rekryteringsroll har behörigheten ”Publicera externt (kostnadsbelagt)” lägga sådana beställningar — från början bara rekryteringens administratörer; varje beställning faktureras den här arbetsytan.',
      switchLabel: 'Tillåt beställning av annonser på externa jobbsajter',
      saving: 'Sparar',
      offHint: 'Att stänga av stoppar bara nya beställningar. Annonser som redan är ute ligger kvar och faktureras tills deras period tar slut.',
      offHintOpenOrders: 'Det ligger annonser ute just nu. Att stänga av stoppar bara nya beställningar — de pågående annonserna ligger kvar och faktureras tills deras period tar slut.',
      roleNote: 'Bara en ägare av arbetsytan, en faktureringsansvarig eller en suite-administratör kan ändra den här inställningen. Den som inte ska beställa annonser stoppas i stället i rekryteringen, genom att behörigheten ”Publicera externt (kostnadsbelagt)” tas bort från rollen.',
      demoNote: 'Det här är en demo-arbetsyta. Inställningarna ersätts när den riktiga uppsättningen görs, så reglaget är låst till dess.',
      noCardTitle: 'Inget betalkort registrerat',
      noCardBody: 'Du kan slå på det nu, men en annonsbeställning kan inte betalas förrän ett kort är registrerat.',
      noCardCta: 'Lägg till kort',
      savedOn: 'Externa annonser är på. Rekryterare ser beställningsavsnittet vid nästa sidladdning.',
      savedOff: 'Externa annonser är av. Inga nya annonser kan beställas; de som redan ligger ute ligger kvar och faktureras.',
    },
    invoiceStatus: { draft: 'Förbereds', issued: 'Utfärdad', sent: 'Skickad', canceled: 'Annullerad' },
    chargeKind: { subscription: 'Prenumeration', proration: 'Proportionerlig avgift', posting: 'Jobbannons', recovery: 'Efterbetalning' },
    posting: { orderRef: 'Beställning {ref}', invoice: 'Ladda ner faktura' },
    chargeStatus: { created: 'Skapad', pending: 'Väntar', paid: 'Betald', failed: 'Misslyckad', authorized: 'Reserverad', order_placed: 'Lagd', capture_requested: 'Dragning begärd', captured: 'Betald', settled: 'Betald', refunded: 'Återbetald', chargeback: 'Återkrav', voided: 'Misslyckad' },
    bill: { label: 'Faktura {number}', labelMany: 'Fakturor {number}', unnumbered: 'Faktura förbereds', paid: 'Betald', closed: 'Avslutad', retry: 'Nytt försök', projected: 'Beräknad' },
    // The promo (issue 808, ADR 0100): one line for the phase the account is in.
    promo: { trial: 'Testperiod till {start} · sedan 1 gratis månad till {end} · kod {code} | Testperiod till {start} · sedan {n} gratis månader till {end} · kod {code}', run: 'Gratis månader till {end} · kod {code}', discount: 'Testperiod till {start} · sedan 1 månad med {percent} % rabatt på platser och moduler · kod {code} | Testperiod till {start} · sedan {n} månader med {percent} % rabatt på platser och moduler · kod {code}', discountRun: '{percent} % rabatt på platser och moduler till {end} · kod {code}', invoiceLine: 'Kampanjkod {code} −{percent} %', referralLine: 'Värvningsbonus −{percent} %', referralLineCapped: 'Värvningsbonus −{percent} % (begränsad)' },
    // A module code typed in the add-module dialog (issue 1029, M2).
    modulePromo: { label: 'Kampanjkod (valfritt)', apply: 'Använd', remove: 'Ta bort', applied: '{code}: {percent} % rabatt på {module} för 1 faktura | {code}: {percent} % rabatt på {module} för {n} fakturor', savesToday: 'Koden drar av {amount} från dagens debitering.', rateLimited: 'För många försök. Vänta några minuter och försök igen.', checkFailed: 'Koden kan inte kontrolleras just nu. Du kan lägga till modulen utan den.', notBooked: 'Inget bokades – du kan lägga till modulen utan koden.', addedWithoutDiscount: 'Koden kunde inte användas, så det blir ingen rabatt.', module: { time_tracking: 'Tidsregistrering' }, trimmed: '{code} ger {percent} %, men din faktura har redan en rabatt – på {module} får du {effective} % (alla rabatter på en faktura har ett tak).', trimmedNothing: '{code} ger {percent} %, men din faktura har redan en rabatt – den här koden tillför just nu inget extra.', pending: 'Vi bekräftar fortfarande din kod – den syns på din nästa faktura när den är bekräftad.', invoiceLine: 'Kampanjkod {code} −{percent} % ({module})', running: '{code}: {percent} % rabatt på 1 faktura till | {code}: {percent} % rabatt på {n} fakturor till', reason: { unknown: 'Vi känner inte igen den här koden. Kontrollera stavningen.', disabled: 'Den här koden har stängts av.', notYetValid: 'Den här koden gäller inte ännu.', expired: 'Den här koden har gått ut.', exhausted: 'Du har redan använt den här koden, eller så är den slut.', moduleNotEligible: 'Den här koden gäller inte för {module}.', wrongCheckout: 'Den här koden är för nya registreringar, inte för att lägga till en modul.', unavailable: 'Den här koden kan inte användas här.' } },
    // The billing door (issue 824): a promo code entered on a running workspace.
    // The workspace's own referral code (issue 824), shown to those who manage billing.
    referral: { title: 'Din värvningskod', copy: 'Kopiera kod', copyLink: 'Kopiera länk till kassan', copied: 'Värvningskoden kopierades', linkCopied: 'Länken till kassan kopierades', friendGets: 'Den som använder den från start betalar {percent} % mindre den första månaden. | Den som använder den från start betalar {percent} % mindre de första {n} månaderna.', youGet: 'När det företaget börjar betala får du {percent} % rabatt på en av dina fakturor. | När det företaget börjar betala får du {percent} % rabatt på {n} av dina fakturor.', rules: 'Flera bonusar läggs ihop — upp till {ceiling} % per faktura.', rulesCapped: 'Flera bonusar läggs ihop — upp till {ceiling} % per faktura, högst {cap} per bonus.', paused: 'Din kod är pausad så länge en raderingsbegäran är öppen för din arbetsyta. Den fungerar igen så fort begäran dras tillbaka.', disabled: 'Den här koden har stängts av och kan inte längre användas.', none: { trialing: 'Du får en värvningskod när din arbetsyta betalar, efter testperioden.', free_run: 'Du får en värvningskod när de gratis månaderna är slut och din arbetsyta betalar.', not_billing: 'Du får en värvningskod när din arbetsyta har en pågående prenumeration.' }, loading: 'Din värvningskod läses in …', error: 'Din värvningskod kunde inte läsas just nu. Försök igen senare.', list: { title: 'Dina värvningar', empty: 'Här visas varje företag som använder din kod — och vad det ger dig.', emptyHint: 'Först testar det, sedan betalar det, sedan väntar din bonus här på att lösas in.', since: 'Värvning den {date}', pill: { testing: 'Testar fortfarande', paying: 'Betalar', ready: 'Redo', running: 'Pågår {x}/{y}' }, invoices: '1 faktura | {n} fakturor', sentence: { testing: 'Din bonus kommer så snart företaget börjar betala.', paying: 'Företaget betalar sedan {date} — din bonus är på väg.', ready: 'Företaget betalar sedan {date} — du får {percent} % rabatt på {invoices}{cap}.', readyCap: ', högst {cap} per faktura', startsOn: 'Din bonus börjar med din faktura den {date}.', startsNext: 'Din bonus börjar med din nästa faktura.', waits: 'Din bonus väntar på plats på en kommande faktura.', carried: '{months} var den första fakturan | {months} var de första fakturorna', nextLast: 'den sista är den från {date}', nextThen: 'nästa är den från {date}, sedan en till | nästa är den från {date}, sedan {n} till', toCome: 'en till kvar | {n} till kvar', done: 'Företaget betalar sedan {date} — din bonus gällde {months}.', doneNone: 'Företaget betalar sedan {date} — din bonus är förbrukad.' }, done: { line: '1 avslutad värvning — den gav dig {percent} % rabatt på {invoices} | {n} avslutade värvningar — varje gav dig {percent} % rabatt på {invoices}', lineMixed: '1 avslutad värvning | {n} avslutade värvningar', show: 'Visa', hide: 'Dölj' }, carries: { items: 'Din nästa faktura den {date} innehåller {items}.', itemsNoDate: 'Din nästa faktura innehåller {items}.', none: 'Din nästa faktura den {date}: utan rabatt.', noneNoDate: 'Din nästa faktura: utan rabatt.', readyNote: 'Inlöst betyder: från och med den här fakturan.' } }, bonus: { collect: 'Lös in', capped: 'begränsad', running: { promo: '{percent} % kampanjkod', module: '{percent} % modulkod', referral: '{percent} % värvningsbonus' }, collected: 'Inlöst — bonusen dras nu av på dina nästa fakturor.', alreadyRunning: 'Den här bonusen pågår redan.', collectFailed: 'Bonusen kunde inte lösas in just nu. Försök igen.', hint: { lead: 'Inte än.', tail: '— bonusen väntar här, inget går förlorat.', ceiling: 'Din nästa faktura innehåller redan {running}, och med den här bonusen skulle den passera gränsen på {ceiling} %', ceilingRunning: 'Din nästa faktura innehåller redan {running}, så det finns inget utrymme för den här bonusen', ceilingLimit: 'Med den här bonusen skulle din nästa faktura passera gränsen på {ceiling} %', ceilingPlain: 'Rabatterna på din nästa faktura lämnar inget utrymme för den här bonusen', roomNext: 'En pågående bonus tar slut med din nästa faktura', roomLater: 'Den första pågående bonusen tar slut efter {n} fakturor till', notActive: 'Din arbetsyta är inte aktiv just nu', deletion: 'En raderingsbegäran är öppen för din arbetsyta', unavailable: 'Just nu går det inte att kontrollera om bonusen kan lösas in; försök igen om en stund' } } },
    errors: { setupFailed: 'Kortinställningen misslyckades.', loadFailed: 'Det gick inte att läsa in faktureringsdata.', ownerOnly: 'Endast arbetsytans ägare kan hantera fakturering.', planChangeFailed: 'Det gick inte att ändra din plan. Försök igen.', paymentStanding: 'Reglera din utestående betalning innan du uppgraderar.', cardRequired: 'Lägg till ett giltigt kort innan du uppgraderar.', addModuleFailed: 'Det gick inte att lägga till modulen. Försök igen.', cancellationPending: 'Din prenumeration kommer att avslutas. Välj först ”Behåll prenumeration” och lägg sedan till modulen.', removeFailed: 'Det gick inte att schemalägga borttagningen. Försök igen.' },
    retry: 'Försök igen',
    common: { close: 'Stäng' },
    card: {
      label: 'Kort', title: 'Betalningsmetod',
      remove: 'Ta bort kort', removed: 'Kortet togs bort.',
      inUse: 'Det här kortet har redan fakturerats och kan endast bytas ut, inte tas bort.',
      removeConfirmTitle: 'Ta bort kort?', removeConfirmBody: 'Detta tar bort det registrerade kortet. Du kan lägga till ett nytt när som helst.',
      removeError: 'Det gick inte att ta bort kortet.',
      handoff: 'Skicka en betalningslänk till någon annan', handoffTitle: 'Betalningslänk',
      handoffHint: '"Lägg till/byt ut kort": du anger kortuppgifterna själv. "Skicka en betalningslänk till någon annan": skicka en engångslänk till den som lägger in kortet — t.ex. din ekonomiavdelning.',
      handoffBody: 'Dela den här engångslänken med den som ska registrera kortet. Den upphör att gälla {date}.',
      copy: 'Kopiera', copied: 'Kopierad', handoffCopied: 'Betalningslänk kopierad', handoffError: 'Det gick inte att skapa en betalningslänk.',
    },
    recovery: {
      title: 'Betalning väntar · {amount}',
      body: 'Din bank behöver bekräfta den här betalningen. Bekräfta den nu så behåller du åtkomsten.',
      cta: 'Bekräfta betalning',
      paid: 'Betalningen har kommit in – din åtkomst är återställd.',
      failed: 'Betalningen slutfördes inte. Du kan försöka igen när som helst.',
      checking: 'Vi kontrollerar fortfarande betalningen…',
      startError: 'Betalningen kunde inte startas just nu. Försök igen om en stund.',
    },
    plan: {
      title: 'Plan och moduler', subtitle: 'Hantera planen för varje aktiv modul.',
      currentPlan: 'Nuvarande plan', current: 'Nuvarande',
      perMonth: '{amount}/mån', perUserMonth: '{amount} per användare/mån.', perApprenticeMonth: '{amount} per lärling/mån.', volumeHint: 'Volymrabatt: större arbetsytor betalar automatiskt mindre per plats.',
      perUpgradeMonth: '{amount} per utökning/mån.',
      upgrade: 'Uppgradera', downgrade: 'Nedgradera', apply: 'Byt plan',
      downgradeNote: 'Nedgraderingar träder i kraft i början av din nästa faktureringsperiod.',
      fixCardCta: 'Åtgärda betalningsmetod',
      enterprise: { title: 'Behöver du mer?', body: 'Större team och anpassade villkor ordnas med vårt team.', cta: 'Kontakta försäljning' },
      provisioning: 'Konfigureras — det kan ta en minut.',
      provisioningFailed: 'Konfigurationen misslyckades — vi tar hand om det.',
      removeModule: 'Ta bort modul', removeConfirmTitle: 'Ta bort modulen?',
      removeConfirmBody: '{module} tas bort i slutet av din nuvarande faktureringsperiod. Du kan ångra det fram till dess.',
      removeScheduled: 'Borttagning av {module} schemalagd.',
      addTitle: 'Lägg till en modul', addSubtitle: 'Utöka din arbetsyta med ytterligare en modul.',
      addCta: 'Lägg till modul', addConfirmTitle: 'Lägg till modulen?',
      moduleLabel: 'Modul', planLabel: 'Plan',
      // The booking table's column heads and its sum row's start date (#409 F12).
      booking: { price: 'Pris', seats: 'Platser', monthly: 'Per månad', from: 'från {date}' },
      apprenticeSeats: 'Bokade lärlingsplatser',
      apprenticeSeatsHint: 'Minst 1 lärlingsplats för utbildningsmodulen.',
      apprenticeSeatsCeiling: 'Över {max} lärlingsplatser finns ingen självbetjäningsplan – vi kommer överens om den direkt med dig:',
      apprenticeSeatAdjustment: 'Du hade bokat {booked} lärlingsplatser innan modulen togs bort, så den har lagts till igen med {booked} platser i stället för de {requested} du bad om. Du kan sänka dem från och med nästa debitering.',
      added: '{module} har lagts till.',
      addedPaymentRetrying: '{module} har lagts till och är redo att användas. Vi kunde inte dra betalningen just nu — vi försöker igen automatiskt.',
      alreadyActive: '{module} ingår redan i din plan.',
    },
    seats: {
      title: 'Bokade platser',
      userSeats: 'Användarplatser', apprenticeSeats: 'Lärlingsplatser',
      stepUp: 'Fler platser', stepDown: 'Färre platser',
      bookMore: 'Boka fler platser',
      confirmTitle: 'Boka fler platser?', confirmCta: 'Boka platser',
      chargeNote: 'Om du bokar fler platser debiteras ett proportionellt belopp för resten av den här faktureringsperioden.',
      confirmTitleDecrease: 'Minska bokade platser?',
      reduceCta: 'Minska platser',
      decreaseNote: 'Inget debiteras eller krediteras i dag — din bokning ändras den {date}.',
      decreaseNoteImmediate: 'Inget debiteras eller krediteras — din bokning ändras direkt.',
      decreaseScheduled: 'Minskning av platser planerad till den {date}.',
      mixedDirection: 'Boka fler platser och minska platser i separata steg: tillagda platser debiteras i dag, minskade platser gäller från din nästa faktureringsperiod.',
      belowUsage: 'Din arbetsyta använder fler platser än så. Behåll minst {count}.',
      usageCheckUnavailable: 'Vi kunde inte kontrollera hur många platser som används just nu. Försök igen om en stund.',
      leaveFreelancer: 'Detta lämnar frilansläget.',
      returnFreelancer: 'Detta tar dig tillbaka till frilansläget — en person, en plats.',
      booked: 'Dina bokade platser har uppdaterats.',
      bookedPaymentRetrying: 'Dina platser är bokade och redo att användas. Vi kunde inte dra betalningen just nu — vi försöker igen automatiskt.',
      bookFailed: 'Platserna kunde inte bokas. Försök igen.',
    },
    seatPanel: {
      inUse: '{used} av {booked} används',
      bookedOnly: '{booked} bokade',
      useUnknown: 'Vi kunde inte läsa av hur många som används just nu.',
      manage: 'Hantera platser',
      pendingUsers: 'Användarplatserna ändras till {target} den {date} — fram till dess är {current} bokade.',
      pendingApprentices: 'Lärlingsplatserna ändras till {target} den {date} — fram till dess är {current} bokade.',
      reflooredUsers: 'Din sänkning till {requested} användarplatser genomfördes på {booked}: {used} personer finns i arbetsytan och var och en upptar en plats. Ta bort dem du inte längre behöver och sänk sedan igen.',
      reflooredApprentices: 'Din sänkning till {requested} lärlingsplatser genomfördes på {booked}: {used} lärlingsutbildningar pågår. Avsluta dem du inte längre behöver och sänk sedan igen.',
      // A demo workspace's apprentices hold no booked seat (issue 364 F4/F30):
      // the creation gate ignores the booking while the demo runs, so the count
      // excludes them and this row says so.
      demoNotCounted: 'Lärlingar i demodata upptar inga bokade platser – de räknas inte här och försvinner när du omvandlar demot.',
    },
    // The seat price calculator (issue 364 F30). Every FIGURE it shows arrives
    // from the API; these are only the words around them.
    calc: {
      title: 'Vad den här bokningen kostar',
      includes: 'Vad din bokning innehåller och vad den kostar per månad.',
      userSeatsCount: '{count} användarplatser',
      apprenticeSeatsCount: '{count} lärlingsplatser',
      aiQuotaUpgradesCount: '{count} × utökning',
      subtotal: 'Delsumma',
      volumeDiscount: 'Volymrabatt',
      monthlyTotal: 'Totalt per månad',
      currentTotal: 'I dag betalar du {amount} per månad.',
      newMonthlyTotal: 'Från din nästa faktura: {amount} per månad.',
      netNote: 'Priser exklusive moms. Att boka fler platser kostar dessutom ett engångsbelopp i proportion till resten av den aktuella faktureringsperioden.',
    },
    // The AI quota card (#665). Every figure it shows arrives from the API.
    aiQuota: {
      title: 'AI-kvot',
      usageLink: 'Vad den används till',
      ownKey: 'Den här arbetsytan använder lumi med en egen nyckel från en AI-leverantör och har därför ingen AI-kvot — din leverantör fakturerar dig direkt för varje token.',
      suspended: 'AI-kvoten är pausad så länge arbetsytan är spärrad.',
      unlimited: 'Ingen AI-kvot gäller för den här arbetsytan — lumi har tagit bort gränsen.',
      intro: 'lumi, AI-funktionerna i alla moduler och de externa AI-agenter som medlemmar ansluter delar på en kvot: upp till {limit} tokens per faktureringsperiod. Den återställs i början av varje faktureringsperiod; oanvända tokens förs inte över.',
      included: 'Ingår',
      includedDerived: 'med dina bokade platser',
      includedOverride: 'fastställd av lumi för den här arbetsytan',
      tokensValue: '{tokens} tokens per faktureringsperiod',
      upgrades: 'Kvotutökningar',
      upgradesNone: 'Inga bokade',
      upgradesValue: 'Bokade: {count} · +{tokens} tokens',
      used: 'Använt den här perioden',
      usedValue: '{used} av {limit} tokens',
      usedNoLimit: '{used} tokens hittills',
      resetsOn: 'Återställs den {date}',
      stepPrice: 'En utökning ger {tokens} tokens till per faktureringsperiod för {amount} per månad.',
      stepUp: 'En utökning till',
      stepDown: 'En utökning färre',
      removeCta: 'Ta bort vid nästa faktureringsdatum',
      confirmTitle: 'Lägga till en utökning av AI-kvoten?',
      confirmTitleDecrease: 'Ta bort en utökning av AI-kvoten?',
      confirmCta: 'Boka utökning',
      trialWarning: 'Det här kostar riktiga pengar, även under din testperiod: ditt kort debiteras i dag i proportion till resten av testperioden, högst för en månad, och därefter varje månad.',
      cardRequired: 'En utökning av AI-kvoten kräver ett aktivt kort, även under testperioden. Lägg först till ditt kort — när det är bekräftat kan du boka utökningen.',
      promoExcluded: 'Din kod gäller inte AI-kvoten: en utökning rabatteras aldrig och debiteras till listpris.',
      chargeNote: 'En utökning debiteras proportionellt för resten av den här faktureringsperioden och gäller direkt.',
      decreaseNote: 'Inget debiteras eller krediteras i dag. Du behåller utökningen till den {date}; därefter gäller den mindre kvoten.',
      decreaseNoteGeneric: 'Inget debiteras eller krediteras i dag — utökningen upphör vid nästa faktureringsdatum.',
      newQuota: 'Därefter: upp till {limit} tokens per faktureringsperiod.',
      changeDelta: '{tokens} tokens · {amount} / månad',
      addCtaPrice: 'Lägg till kvotutökning · {amount} / månad',
      booked: 'Dina utökningar av AI-kvoten har uppdaterats.',
      bookedPaymentRetrying: 'Din utökning av AI-kvoten är bokad och gäller direkt. Vi kunde inte dra betalningen just nu — vi försöker igen automatiskt.',
      decreaseScheduled: 'Utökningen av AI-kvoten upphör den {date}.',
      pending: 'Kvotutökningarna ändras till {target} den {date} — fram till dess är {current} bokade.',
      bookFailed: 'Utökningarna av AI-kvoten kunde inte ändras. Försök igen.',
    },
    scheduled: {
      resizeTo: 'Byt till {plan}', remove: 'Ta bort modul',
      effective: 'gäller från {date}', revert: 'Ångra', reverted: 'Den schemalagda ändringen har ångrats.',
    },
    proration: {
      title: 'Bekräfta planändring', stepFrom: 'Nuvarande', stepTo: 'Ny',
      chargeNote: 'Om du uppgraderar nu debiteras ett proportionellt belopp för resten av den här faktureringsperioden.',
      freeNote: 'Den här ändringen gäller omedelbart utan extra kostnad under din testperiod.',
      confirm: 'Bekräfta och uppgradera', cancel: 'Avbryt',
      charged: 'Debiterade {amount}.', appliedImmediate: 'Din nya plan är aktiv.',
      appliedScheduled: 'Schemalagd — gäller från {date}.',
      calculating: 'Vi räknar ut det exakta beloppet…',
      chargeExact: 'Du debiteras {amount} idag.',
      noChargeToday: 'Ingen debitering idag.',
    },
    profile: {
      title: 'Faktureringsuppgifter', subtitle: 'Fyll i dina faktureringsuppgifter för att aktivera betalning.',
      legalName: 'Juridiskt företagsnamn', addressLine1: 'Adress', addressLine2: 'Adressrad 2',
      postalCode: 'Postnummer', city: 'Ort', vatId: 'Momsregistreringsnummer',
      vatOptional: 'Valfritt — krävs för omvänd skattskyldighet inom EU.',
      save: 'Spara uppgifter', edit: 'Redigera faktureringsuppgifter', error: 'Det gick inte att spara dina faktureringsuppgifter.',
      saved: 'Faktureringsuppgifter sparade.',
      vatPending: 'Vi kunde inte verifiera ditt momsregistreringsnummer just nu. Försök igen om en stund.',
      vatInvalid: 'Det här momsregistreringsnumret kunde inte valideras. Kontrollera det.',
      vatRequired: 'Ett giltigt momsregistreringsnummer krävs för ditt land innan du lägger till ett kort.',
      completeFirst: 'Fyll i dina faktureringsuppgifter innan du lägger till ett kort.',
    },
    cancel: {
      title: 'Säg upp prenumeration',
      body: 'Säg upp din prenumeration. Din arbetsyta förblir aktiv fram till slutet av den nuvarande faktureringsperioden.',
      reason: 'Anledning (valfritt)', confirm: 'Säg upp prenumeration', confirmTitle: 'Säga upp prenumeration?',
      confirmBody: 'Din prenumeration upphör {date}. Fram till dess fungerar allt som vanligt.',
      note: 'Fram till dess fungerar allt, även exporten av hela arbetsytan. Därefter stängs arbetsytan; dess data finns kvar en tid, och ägarna får veta det innan något raderas. Ska den bort tidigare går det via ”{deletion}”.',
      pending: 'Uppsägning schemalagd — din prenumeration upphör {date}.', pendingNoDate: 'Uppsägning schemalagd.',
      revert: 'Behåll prenumeration', error: 'Det gick inte att säga upp din prenumeration.',
      done: 'Uppsägning schemalagd. Din arbetsyta är aktiv till slutet av den aktuella faktureringsperioden.', revertDone: 'Uppsägningen återkallad. Din prenumeration fortsätter som vanligt.',
    },
    deletion: {
      title: 'Radera arbetsyta (GDPR)',
      body: 'Begär permanent radering av den här arbetsytan och all dess data. Efter en kort respitperiod kan detta inte ångras.',
      request: 'Begär radering', reason: 'Anledning (valfritt)',
      confirmTitle: 'Begära radering av arbetsyta?',
      confirmBody: 'All data raderas permanent efter en kort respitperiod. Detta kan inte ångras.',
      pending: 'Radering begärd — data raderas efter {date}.', pendingNoDate: 'Radering begärd och väntar på granskning.',
      cancel: 'Avbryt raderingsbegäran', error: 'Det gick inte att skicka in din raderingsbegäran.',
      requested: 'Radering begärd. Vi raderar din arbetsyta efter respitperioden.', canceled: 'Raderingsbegäran återkallad. Din arbetsyta finns kvar.',
      confirmType: 'Skriv arbetsytans namn ({name}) för att bekräfta',
      cancelConfirmTitle: 'Återkalla raderingsbegäran?',
      cancelConfirmBody: 'Din arbetsyta och all data behålls. Du kan begära radering igen när som helst.',
    },
    moduleNames: { core: 'lumi-HR Core', ats: 'Rekrytering', time_tracking: 'Tid', apprenticeship: 'Ausbildung' },
    planNames: {
      ats: { seat: 'Per användare', enterprise: 'Enterprise', unknown: '—' },
      time: { seat: 'Per användare', enterprise: 'Enterprise', unknown: '—' },
      apprenticeship: { seat: 'Per lärling', enterprise: 'Enterprise', unknown: '—' },
      // People Pro is retired (#596), but issued invoices keep their `peoplePro.seat`
      // line (GoBD) and render through this entry — keep it while any exists.
      peoplePro: { seat: 'Per användare', enterprise: 'Enterprise', unknown: '—' },
      // The AI quota upgrade line (#665): its displayKey is `ai_quota.upgrade`.
      ai_quota: { upgrade: 'Utökning av AI-kvoten (+1 000 000 tokens per faktureringsperiod)' },
    },
    onboard: {
      // Three honest branches, never a CTA without a control (#364 F18/F23).
      // `exempt` is checked FIRST, ahead of demo: an operator-granted exemption
      // is a deliberate state, not a broken signup and not a demo limitation.
      exempt: { title: 'Den här arbetsytan är undantagen från fakturering', body: 'lumi har kommit överens om att den här arbetsytan inte faktureras, så den har inget faktureringskonto och ingenting debiteras nu eller senare. Bara lumi kan ändra det — det finns inget att ställa in här.' },
      demo: { title: 'Fakturering är inte tillgänglig i demoläge', body: 'Den här arbetsytan använder demodata, så det finns ännu inget att fakturera. Fakturering kan konfigureras när du omvandlar demon till en riktig konfiguration — demobannern högst upp på sidan startar det.' },
      // The stranded signup's real recovery is the buyer redoing the SAME checkout,
      // which resumes THIS workspace (issue 364 F25) — support is the fallback, and
      // for anyone who is not the buyer it is the only route they have.
      stranded: { title: 'Konfigurationen av faktureringen slutfördes inte', buyerBody: 'Din registrering slutfördes inte, så den här arbetsytan har ännu inget faktureringskonto och inget debiteras. Du kan slutföra det själv: gå tillbaka till kassan och beställ samma moduler igen — då återupptas den här arbetsytan i stället för att en andra skapas. Om det ändå inte går igenom, hör av dig, så slutför vi det tillsammans.', otherBody: 'Din registrering slutfördes inte, så den här arbetsytan har ännu inget faktureringskonto och inget debiteras. Bara den som registrerade arbetsytan kan slutföra det, genom att gå tillbaka till kassan och beställa samma moduler igen. Be den personen om det, eller hör av dig, så slutför vi det tillsammans.', checkoutCta: 'Tillbaka till kassan', cta: 'Kontakta supporten' },
    },
    // The four documents this workspace's billing relationship is
    // governed by, on the landing host (#576 M2) — not a "version you
    // accepted" claim, just the current published text.
    contractDocuments: {
      title: 'Avtalsdokument',
      terms: 'Allmänna villkor',
      avv: 'Personuppgiftsbiträdesavtal (AVV)',
      tom: 'Tekniska och organisatoriska åtgärder (TOM)',
      subprocessors: 'Underbiträden',
    },
  },
  login: {
    ssoApple: 'Logga in med Apple',
    passkeySignIn: 'Logga in med en nyckel',
    passkeySigningIn: 'Loggar in…',
    passkeyFailed: 'Inloggning med nyckel misslyckades. Försök igen eller använd ditt lösenord.',
    title: 'lumi-HR Suite',
    subtitle: 'Logga in för att fortsätta',
    email: 'E-post',
    emailPlaceholder: "namn{'@'}foretag.se",
    password: 'Lösenord',
    passwordPlaceholder: 'Ditt lösenord',
    signIn: 'Logga in',
    signingIn: 'Loggar in…',
    failed: 'Inloggningen misslyckades',
    forgotPassword: 'Glömt lösenordet?',
    lostPhone: 'Tappat telefonen?',
    orContinueWith: 'eller fortsätt med',
    ssoGoogle: 'Logga in med Google',
    ssoMicrosoft: 'Logga in med Microsoft',
    ssoEnterprise: 'Logga in med företagets SSO',
    ssoOnly: 'Inloggning i den här arbetsytan sker via ditt företags SSO.',
    adminLogin: 'Administratörsinloggning',
    ssoError: 'SSO-inloggningen misslyckades. Försök igen.',
    ssoSeatLimit: 'Den här arbetsytan har ingen ledig användarplats, så vi kunde inte skapa något konto åt dig. Be arbetsytans ägare eller en Billing Manager att boka en till plats — att försöka igen hjälper inte förrän de gör det.',
    ssoLinkRequired: 'Den här företagsinloggningen kunde inte kopplas till ditt lumi-konto automatiskt. Logga in på annat sätt och koppla sedan företagsinloggningen under Konto och säkerhet.',
    ssoEmployeeNoticeIncomplete: 'Den här arbetsytan är inte redo än: meddelandena för anställda har fortfarande öppna fält. Be arbetsytans ägare, en suite-administratör eller dataskyddsombudet att fylla i dem i avsnittet för juridisk information — att försöka igen hjälper inte förrän de gör det.',
    ssoLegalReadinessUnavailable: 'Vi kunde inte kontrollera just nu om den här arbetsytan är redo. Försök igen om några minuter.',
    ssoOperatorPasswordOnly: 'Systemadministratörskonton loggar in med lösenord och autentiseringsapp, inte via den här leverantören.',
    mfaTitle: 'Ange din autentiseringskod',
    mfaIntro: 'Det här är ett systemadministratörskonto. Ange den 6-siffriga koden från din autentiseringsapp eller en av dina återställningskoder.',
    mfaCode: 'Kod',
    mfaSubmit: 'Logga in',
    mfaBack: 'Tillbaka',
    mfaInvalid: 'Koden är inte korrekt.',
    mfaReused: 'Koden har redan använts. Vänta på nästa i din app.',
    mfaExpired: 'Inloggningen har gått ut. Logga in igen med ditt lösenord.',
    mfaEnrolOnConsole: 'Det här systemadministratörskontot har ingen autentiseringsapp ännu. Ställ in den först genom att logga in i lumi-konsolen.',
    tenantLogoAlt: 'Arbetsytans logotyp',
    poweredBy: 'Drivs av',
  },
  loginBranding: {
    nav: 'Inloggningssida',
    title: 'Inloggningssida',
    intro: 'Ge den här arbetsytans inloggningssida en egen logotyp, egen färg och egen bakgrundsbild. Alla som loggar in här ser den.',
    retry: 'Försök igen',
    loadFailed: 'De nuvarande inställningarna kunde inte hämtas.',
    form: {
      title: 'Utseende',
      logo: 'Logotyp',
      logoHint: 'PNG, JPEG, WebP eller GIF, upp till 2 MB. Lämna tomt för att behålla lumis logotyp.',
      image: 'Bakgrundsbild',
      imageHint: 'Visas bakom inloggningskortet. PNG, JPEG, WebP eller GIF, upp till 8 MB.',
      upload: 'Ladda upp',
      replace: 'Ersätt',
      remove: 'Ta bort',
      empty: 'Ingen bild',
      uploaded: 'Bilden har laddats upp.',
      removed: 'Bilden har tagits bort.',
      tooLarge: 'Filen är för stor.',
      wrongType: 'Endast PNG-, JPEG-, WebP- och GIF-bilder accepteras.',
      uploadFailed: 'Bilden kunde inte laddas upp. Försök igen.',
      removeFailed: 'Bilden kunde inte tas bort. Försök igen.',
      removeConfirm: 'Bilden tas bort från inloggningssidan och raderas. Det går inte att ångra.',
      primaryColor: 'Primärfärg',
      primaryColorHint: 'Färgar arbetsytans namn, länkarna och inloggningsknappen.',
      boxColor: 'Rutans färg',
      boxColorHint: 'Rutan som inloggningsformuläret ligger i.',
      boxColorInvalid: 'Ange en hexfärg, till exempel #ffffff.',
      boxOpacity: 'Rutans opacitet',
      boxTone: 'Text och fält',
      boxToneHint: 'Föreslås utifrån rutans färg. Byt om texten är svår att läsa.',
      toneLight: 'Ljus ruta, mörk text',
      toneDark: 'Mörk ruta, ljus text',
      nothingToSave: 'Inget att spara: inget har ändrats sedan du sparade senast.',
      fixFirst: 'Rätta det markerade fältet först.',
      colorPlaceholder: 't.ex. 1a2b3c',
      colorInvalid: 'Ange en hexfärg, till exempel 1a2b3c.',
      clear: 'Rensa',
      save: 'Spara',
      saved: 'Inloggningssidan har uppdaterats.',
      discard: 'Förkasta',
      liveNote: 'Sparade ändringar syns nästa gång inloggningssidan öppnas.',
    },
    preview: {
      title: 'Förhandsvisning',
      hint: 'Så här ser inloggningssidan ut med värdena ovan.',
      logoAlt: 'Förhandsvisning av logotyp',
    },
  },
  authFlow: {
    forgot: {
      title: 'Återställ ditt lösenord',
      subtitle: 'Vi skickar dig en länk för att återställa det.',
      email: 'E-post',
      submit: 'Skicka länk',
      done: 'Om det finns ett konto med den e-postadressen har vi skickat en återställningslänk.',
      backToLogin: 'Tillbaka till inloggning',
    },
    reset: {
      title: 'Ange ett nytt lösenord',
      password: 'Nytt lösenord',
      confirm: 'Bekräfta lösenord',
      submit: 'Spara lösenord',
      success: 'Ditt lösenord har ändrats. Du kan nu logga in.',
      goToLogin: 'Gå till inloggning',
      invalid: 'Den här länken är ogiltig eller har upphört att gälla.',
      mismatch: 'Lösenorden matchar inte.',
      tooShort: 'Lösenordet måste vara minst 8 tecken.',
      missingToken: 'Ingen giltig token hittades.',
    },
    invite: {
      title: 'Konfigurera ditt konto',
      subtitle: 'Välj ett lösenord för att aktivera ditt konto.',
      forTenant: 'Inbjudan till {tenant}',
      password: 'Lösenord',
      confirm: 'Bekräfta lösenord',
      submit: 'Aktivera konto',
      submitting: 'Aktiverar…',
      invalid: 'Den här inbjudan är ogiltig eller har upphört att gälla.',
      mismatch: 'Lösenorden matchar inte.',
      tooShort: 'Lösenordet måste vara minst 8 tecken.',
      passkey: {
        title: 'Konfigurera din inloggning',
        intro: 'Du loggar in i lumi med en nyckel: fingeravtryck, ansikte eller enhetens PIN. Inget lösenord att komma ihåg.',
        sentTo: 'Skickat till {phone}',
        create: 'Skapa en nyckel',
        creating: 'Väntar på din enhet…',
        instead: 'Använd en nyckel i stället',
        or: 'eller',
        unsupported: 'Den här webbläsaren kan inte skapa en nyckel. Öppna länken på din telefon eller i en uppdaterad webbläsare.',
        unavailable: 'Nycklar är inte tillgängliga här för den här arbetsytan. Kontakta din administratör.',
        expired: 'Det tog för lång tid. Försök igen.',
        alreadyRegistered: 'Den här enheten har redan en nyckel för lumi.',
        failed: 'Nyckeln kunde inte skapas. Försök igen.',
      },
    },
    recover: {
      title: 'Tappat telefonen?',
      subtitle: 'Ange ditt mobilnummer så skickar vi ett sms med en länk där du skapar en ny nyckel.',
      phone: 'Mobilnummer',
      phoneHint: 'Med landsnummer, t.ex. +46 70 123 45 67',
      submit: 'Skicka länk',
      done: 'Om numret hör till ett konto här har vi skickat en länk till det. Den gäller i 15 minuter.',
      enrolTitle: 'Skapa en ny nyckel',
      enrolSubtitle: 'Skapa en nyckel på den här enheten. Alla andra sessioner för ditt konto loggas ut.',
      create: 'Skapa en ny nyckel',
      invalid: 'Länken är ogiltig eller har upphört att gälla. Begär en ny.',
    },
    verify: {
      verifying: 'Bekräftar din e-post…',
      success: 'Din e-postadress har bekräftats.',
      invalid: 'Den här bekräftelselänken är ogiltig eller har upphört att gälla.',
      backToLogin: 'Gå till inloggning',
    },
  },
  account: {
    // AI agent connections on the account page (ADR 0103 rule 13).
    agentConnections: {
      title: 'Anslutningar för AI-agenter',
      hint: 'AI-klienter som du har låtit agera som du i en arbetsyta. Var och en arbetar med exakt dina behörigheter, och det den läser går till klientens leverantör.',
      none: 'Ingen AI-agent är ansluten.',
      inWorkspace: 'i arbetsytan {workspace}',
      scope: {
        read: 'läsa',
        act: 'agera med bekräftelse',
        ask: 'fråga lumi',
      },
      lastUsed: 'Senast använd {when}',
      connectedOn: 'Ansluten {when}, ännu inte använd',
      standing: {
        label: 'Utför åtgärder på mina egna poster utan att fråga',
        hint: 'Gäller aldrig andra personers poster eller negativa beslut.',
        notOffered: 'Den här anslutningen kan inte få ett stående samtycke.',
        failed: 'Inställningen kunde inte ändras. Försök igen.',
      },
      rolePins: {
        notHeld: 'Du har inte längre den rollen i den här modulen.',
        failed: 'Rollen kunde inte ändras. Försök igen.',
      },
      disconnect: 'Koppla från',
      disconnectConfirm: '”{client}” förlorar omedelbart åtkomsten till {workspace}. För att använda den igen ansluter du den på nytt från klienten.',
      disconnected: '{client} har kopplats från.',
      disconnectFailed: 'Anslutningen kunde inte avslutas. Försök igen.',
    },
    passkeys: {
      removeConfirm: 'Den här passkeyn tas bort. Enheten som använder den kan inte längre logga in med den.',
      title: 'Nycklar',
      hint: 'En nyckel loggar in dig med din enhet — fingeravtryck, ansikte eller PIN. Inget att komma ihåg och inget att nätfiska.',
      none: 'Inga nycklar än.',
      add: 'Lägg till en nyckel',
      remove: 'Ta bort',
      unnamed: 'Nyckel',
      lastUsed: 'Senast använd {when}',
      neverUsed: 'Aldrig använd',
      added: 'Nyckeln har lagts till.',
      removed: 'Nyckeln har tagits bort.',
      addFailed: 'Nyckeln kunde inte läggas till. Försök igen.',
      removeFailed: 'Nyckeln kunde inte tas bort. Försök igen.',
      alreadyRegistered: 'Den här enheten har redan en nyckel för lumi.',
      lastMethod: 'Du kan inte ta bort din enda inloggningsmetod. Sätt först ett lösenord eller lägg till en nyckel till.',
      lostDevice: 'Tappat en telefon eller annan enhet? Ta bort dess nyckel från listan — det är det som stänger ute den från ditt konto.',
    },
    currentPassword: 'Nuvarande lösenord',
    phone: {
      title: 'Inloggningsnummer',
      hint: 'Ditt konto loggar in med en nyckel. Till det här numret skickas dina inbjudnings- och återställningslänkar.',
    },
    email: {
      title: 'Inloggningsadress',
      hint: 'Adressen du loggar in med. Ändrar du den ändras också adressen som dina arbetsytor visar för dig.',
      newLabel: 'Ny adress',
      submit: 'Begär ändring',
      pending: 'Väntar på bekräftelse på {email}. Följ länken vi skickade dit.',
      cancel: 'Avbryt ändringen',
      cancelled: 'Den väntande adressändringen avbröts.',
      sent: 'Titta i den nya brevlådan. Ingenting ändras förrän du följer länken.',
      refused: 'Den adressen kan inte användas för det här kontot. En av dina arbetsytor tillåter bara inloggningsadresser på egna domäner.',
      failed: 'Ändringen kunde inte begäras. Försök igen.',
      ssoManaged: 'Din inloggningsadress hanteras av din identitetsleverantör.',
    },
    password: {
      title: 'Lösenord',
      hint: 'Att byta lösenord loggar ut dig överallt annars.',
      newLabel: 'Nytt lösenord',
      confirmLabel: 'Upprepa nytt lösenord',
      submit: 'Byt lösenord',
      changed: 'Ditt lösenord har bytts. Övriga enheter har loggats ut.',
      wrongCurrent: 'Det nuvarande lösenordet stämmer inte.',
      failed: 'Lösenordet kunde inte bytas. Försök igen.',
      tooShort: 'Det nya lösenordet måste vara minst 8 tecken.',
      mismatch: 'De två nya lösenorden stämmer inte överens.',
      ssoOnly: 'Det här kontot loggar in via din identitetsleverantör och har därför inget lösenord. Du kan lägga till ett som reserv — vi mejlar dig en länk.',
      sendLink: 'Mejla mig en länk för att sätta ett lösenord',
      linkSent: 'Om ett lösenord kan sättas för det här kontot är en länk på väg.',
      linkFailed: 'Begäran kunde inte skickas. Försök igen.',
    },
    confirmEmail: {
      title: 'Bekräfta din nya adress',
      working: 'Bekräftar…',
      success: 'Din inloggningsadress har ändrats. Logga in igen med den nya adressen.',
      goToLogin: 'Till inloggningen',
      backToAccount: 'Tillbaka till Konto och säkerhet',
      missingToken: 'Länken är ofullständig. Öppna den direkt från mejlet.',
      invalid: 'Den här bekräftelselänken är ogiltig eller har gått ut.',
      unavailable: 'Ändringen kan inte längre genomföras. Begär den på nytt.',
    },
    // The undo half (#420): the notice mailed to the address being LEFT
    // BEHIND carries this link, and it only ever restores the status quo.
    cancelEmailChange: {
      title: 'Avbryt ändringen av adressen',
      working: 'Avbryter…',
      success: 'Ändringen avbröts. Du loggar fortfarande in med din nuvarande adress.',
      goToLogin: 'Till inloggningen',
      missingToken: 'Länken är ofullständig. Öppna den direkt från e-postmeddelandet.',
      invalid: 'Länken är ogiltig eller har gått ut – det finns ingen ändring kvar att avbryta.',
    },
    title: 'Konto och säkerhet',
    identities: 'Länkade inloggningsmetoder',
    noIdentities: 'Inga externa inloggningsmetoder länkade.',
    unlink: 'Ta bort',
    // #882: removing a linked sign-in method asks first, as removing a passkey does.
    unlinkConfirm: 'Den här inloggningsmetoden tas bort. Du kan inte längre logga in på ditt konto med den.',
    linkGoogle: 'Länka Google',
    linkMicrosoft: 'Länka Microsoft',
    linkApple: 'Länka Apple',
    lastMethod: 'Du kan inte ta bort din enda inloggningsmetod. Ange ett lösenord först.',
    linked: 'Inloggningsmetod länkad.',
    unlinked: 'Inloggningsmetod borttagen.',
    linkFailed: 'Länkningen misslyckades.',
  },
  workspace: {
    title: 'Arbetsyta',
    subtitle: 'Välj en tenant och modul',
    brandName: 'lumi-HR Workspace',
    themeDark: 'Växla till mörkt läge',
    themeLight: 'Växla till ljust läge',
    welcomeTitle: 'Välkommen till arbetsytan',
    welcomeSubtitle: 'Välj din tenant och en applikationsmodul för att börja.',
    availableModules: 'Tillgängliga moduler',
    comingSoonSection: 'Kommer snart i lumi-HR',
    adminMode: 'Adminläge',
    aiUsage: {
      title: 'AI-användning',
      pageIntro: 'Om lumi är tillgängligt i den här arbetsytan – och vad AI:n har förbrukat den här månaden.',
      loading: 'Laddar användning…',
      remaining: '{n} kvar',
      periodLabel: 'Faktureringsperiod',
      historyTitle: 'Faktureringsperioder',
      usedThisPeriod: 'Använt den här faktureringsperioden',
      split: '{included} ingår · +{upgrades} från kvotutökningar',
      resetsOn: 'Återställs den {date}',
      periodFrom: 'Faktureringsperiod från {date}',
      nearLimit: 'Den här faktureringsperiodens AI-kvot är nästan förbrukad. En kvotutökning under Fakturering höjer den direkt.',
      unlimited: 'Ingen AI-kvot gäller för den här arbetsytan.',
      ownKey: 'Den här arbetsytan använder lumi med en egen nyckel från en AI-leverantör och har därför ingen AI-kvot.',
      noUsageYet: 'Ingen AI-användning ännu den här faktureringsperioden.',
      upgradeLink: 'Lägg till en kvotutökning under Fakturering',
      modules: {
        ats: 'Rekrytering',
        time: 'Tid',
        time_tracking: 'Tid',
        apprentice: 'Ausbildung',
        apprenticeship: 'Ausbildung',
        assistant: 'lumi-assistent',
        mcp: 'Externa agenter',
      },
    },
    active: 'Aktiv',
    systemAdmin: 'Systemadministratör',
    user: 'Användare',
    admin: 'Administration',
    comingSoon: 'Kommer snart',
    noTenants: 'Inga tenants tillgängliga',
    createViaCheckout: 'Skapa en arbetsyta via kassan',
    loadFailed: 'Kunde inte ladda tenants',
    planKlein: 'Liten',
    planMedium: 'Medium',
    planEnterprise: 'Enterprise',
    retry: 'Försök igen',
    logout: 'Logga ut',
    noAccess: 'Ingen åtkomst',
  },
  support: {
    title: 'Supportärenden',
    myTickets: 'Mina ärenden',
    myTicketsTitle: 'Mina supportärenden',
    inbox: 'Inkorg',
    inboxTitle: 'Supportinkorg',
    inboxSubtitle: 'Ärenden från de tenants du stödjer',
    ticket: 'Ärende',
    newTicket: 'Nytt supportärende',
    newTicketTitle: 'Nytt supportärende',
    newTicketIntro: 'Beskriv ditt problem så återkommer vi till dig.',
    sent: 'Din förfrågan har skickats.',
    goToMyRequests: 'Gå till mina supportärenden',
    subject: 'Ämne',
    subjectPlaceholder: 'Kort sammanfattning',
    message: 'Meddelande',
    messagePlaceholder: 'Beskriv vad som hände…',
    consentLabel: 'Jag samtycker till att mina uppgifter behandlas för att hantera denna begäran',
    send: 'Skicka',
    reply: 'Svara',
    markComplete: 'Markera som klar',
    reopen: 'Öppna igen',
    replyPlaceholder: 'Skriv ett svar…',
    escalate: 'Eskalera',
    escalated: 'Eskalerat',
    deescalate: 'Avbryt eskalering',
    deescalateBlocked: 'Det finns fortfarande en öppen supportåtkomst för det här ärendet. Återkalla den först och avbryt sedan eskaleringen.',
    close: 'Stäng',
    statusLabel: 'Status',
    module: 'Modul',
    tenant: 'Tenant',
    requester: 'Beställare',
    updated: 'Uppdaterad',
    backToTickets: 'Tillbaka till mina ärenden',
    status: {
      open: 'Öppet',
      in_progress: 'Pågår',
      answer: 'Besvarat',
      closed: 'Stängt',
    },
    author: {
      user: 'Du',
      support: 'Support',
      systemAdmin: 'Systemadministratör',
    },
    empty: {
      myTitle: 'Inga ärenden ännu',
      myBody: 'När du skapar ett supportärende visas det här.',
      inboxTitle: 'Inget att stödja',
      inboxBody: 'Du har inga supportärenden i dina tenants just nu.',
      notFoundTitle: 'Ärendet är inte tillgängligt',
      notFoundBody: 'Det här ärendet kunde inte laddas. Det kan ha tagits bort eller så saknar du åtkomst.',
    },
  },
  notifications: {
    nav: 'Aviseringar',
    title: 'Aviseringar',
    subtitle: 'Saker som kräver din uppmärksamhet.',
    settings: 'Inställningar',
    backToWorkspace: 'Tillbaka till arbetsytan',
    area: 'Område',
    areaAll: 'Alla områden',
    status: 'Status',
    statusAll: 'Alla',
    statusUnread: 'Olästa',
    statusRead: 'Lästa',
    perPage: 'Per sida',
    markRead: 'Markera som läst',
    markUnread: 'Markera som oläst',
    markAllRead: 'Markera alla som lästa',
    loading: 'Laddar…',
    empty: 'Du är ikapp.',
    pageInfo: '{from}–{to} av {total}',
    prev: 'Föregående',
    next: 'Nästa',
    retentionHint: 'Aviseringar sparas i 6 månader.',
    settingsTitle: 'Konfigurera aviseringar per område',
    settingsSubtitle: 'Välj hur du vill aviseras för varje område.',
    // #445 M4 packet 2: the settings screen must say plainly what it cannot
    // switch off, and what a switched-off Area still lets through.
    mustReachIntro: 'Några meddelanden om säkerhet, pengar, avtal, din arbetsyta och lagstadgade tidsfrister når alltid de personer de berör — de visas också i klockan.',
    // A phone-only account (issue 698): no address, so the mail half never goes out.
    noMailAddress: 'Ditt konto har ingen e-postadress, så meddelanden når dig i appen (och som pushnotis där du har tillåtit det). ”{mailMode}” fungerar därför som ”{inAppMode}”: ingenting skickas med e-post.',
    mustReachStillReaches: 'Även om du stänger av det här når {list} dig fortfarande när det berör dig.',
    mandatoryReason: {
      billing: 'Kan inte stängas av: pengar du är skyldig måste nå den ansvariga personen.',
      legal: 'Kan inte stängas av: avtalsändringar måste nå dig, precis som våra villkor lovar.',
    },
    mustReachFamily: {
      identity: 'säkerhetsmeddelanden',
      money: 'faktureringsmeddelanden',
      legal: 'avtalsmeddelanden',
      workspace: 'meddelanden om arbetsytans status',
      privacy: 'påminnelser om integritetsfrister',
      participation: 'förfrågningar till personalrepresentanterna',
    },
    backToList: 'Tillbaka till aviseringar',
    modeOff: 'Inte alls',
    modeInApp: 'Endast i appen',
    modeMailInApp: 'E-post och i appen',
    saved: 'Sparat.',
    saveError: 'Det gick inte att spara. Inställningen har återställts.',
    openTarget: 'Öppna det länkade objektet',
    opening: 'Öppnar…',
    openFailed: 'Det gick inte att öppna aviseringen.',
    areas: {
      system: 'System',
      timecard: 'Tid',
      ats: 'Rekrytering',
      apprentice: 'Ausbildung',
      people: 'Personal',
      support: 'Support',
      postings: 'Jobbannonser',
      // Subscription, invoices, payment problems. A MANDATORY Area — the
      // row renders without a mode selector (review finding 3).
      billing: 'Fakturering',
      // #373 M5: the contract-rollout notices (AGB, AVV, subprocessors). A
      // MANDATORY Area — the row renders without a mode selector.
      legal: 'Avtalsdokument',
    },
  },
  homebase: {
    // The owner's own details, asked for on Suite Home until given (issue 812); skipping asks first.
    ownDetails: {
      save: 'Spara mina uppgifter',
      later: 'Senare',
      saved: 'Tack – dina uppgifter är sparade.',
      skip: {
        title: 'Hoppa över dina uppgifter?',
        body: 'Tills du fyller i dina uppgifter förblir din egen post i Personal obekräftad. Det betyder: inga anställningsuppgifter som avtal, ledighet eller lön kan läggas till, du kan inte anges som någons chef och du visas som ”obekräftad” i Personal. Du kan göra det när som helst – påminnelsen kommer tillbaka i morgon.',
        fill: 'Fyll i nu',
        skip: 'Hoppa över för nu',
      },
    },
    // The quiet "set up Lumi" panel on Suite Home: one fixed table of entries,
    // each a title + one benefit line; the rows are looked up per entry key.
    setup: {
      title: 'Ställ in lumi',
      subtitle: 'Inget av detta är obligatoriskt. Allt lönar sig när du är redo.',
      hide: 'Behöver inte det här längre',
      viewAll: 'Se allt lumi kan',
      rareHeading: 'Behövs mer sällan',
      page: {
        title: 'Vad lumi kan.',
        subtitle: 'Allt som går att ställa in. Det viktigaste först, resten när du behöver det.',
        tipsTitle: 'Tips på startsidan',
        tipsShown: 'Panelen ligger överst på din startsida tills du inte behöver den längre.',
        tipsHidden: 'Du har dolt panelen. Här får du tillbaka den.',
        emptyTitle: 'Här finns inget för dig att ställa in.',
        emptyBody: 'Det som går att ställa in sköts av de ansvariga i ditt team. Fråga dem om något saknas.',
      },
      sections: {
        suite: 'Hem',
        ats: 'Rekrytering',
        time: 'Tid',
        people: 'Personal',
        apprentice: 'Ausbildung',
      },
      entries: {
        login_branding: { title: 'Utforma inloggningssidan', hint: 'Logotyp och färger, så att ditt team ser att det är rätt ställe.' },
        portal_design: { title: 'Utforma karriärportalen', hint: 'Så ser sökande ert företag först.' },
        email_templates: { title: 'E-postmallar', hint: 'Bekräftelse, inbjudan, avslag: skriv en gång, använd alltid.' },
        job_posting_settings: { title: 'Uppgifter för jobbannonser', hint: 'Logotyp och kontaktperson. Externa jobbsajter behöver båda.' },
        work_time_models: { title: 'Arbetstidsmodeller', hint: 'Vem som arbetar hur många timmar vilka dagar.' },
        company_holidays: { title: 'Företagsstängningar', hint: 'Dagar då verksamheten är stängd.' },
        data_import: { title: 'Importera personer', hint: 'Ta över befintliga listor i stället för att skriva in allt.' },
        company_profile: { title: 'Företagsprofil', hint: 'Adress och grunduppgifter som lumi använder på många ställen.' },
        org_units: { title: 'Organisationsenheter', hint: 'Avdelningar och orter som mycket sorteras efter.' },
        payroll_handover: { title: 'Löneöverföring (DATEV)', hint: 'lumi levererar timmarna, din lönebyrå räknar ut lönen.' },
        training_occupations: { title: 'Utbildningsyrken', hint: 'Vilka yrken ni utbildar i.' },
        workflows: { title: 'Workflows', hint: 'Egna steg och godkännanden i rekryteringsprocessen.' },
        application_forms: { title: 'Ansökningsformulär', hint: 'Vilka frågor sökande svarar på.' },
        offer_templates: { title: 'Erbjudandemallar', hint: 'Förbereda avtalserbjudanden med platshållare.' },
        custom_fields: { title: 'Egna fält', hint: 'Extra uppgifter på tjänster och ansökningar.' },
        booking_types: { title: 'Bokningstyper', hint: 'Vad som kan bokas utöver arbetstid.' },
        leave_types: { title: 'Frånvarotyper', hint: 'Semester, sjukdom och era egna typer.' },
        api_settings: { title: 'Gränssnitt (API)', hint: 'Lämna över tider till egna program via API:t. Löneöverföringen finns under Personal.' },
        time_clock: { title: 'Stämpelklocka', hint: 'Öppna den i webbläsaren på en surfplatta på arbetsplatsen: var och en loggar in där med sin egen lumi-inloggning och stämplar in eller ut.' },
        sso: { title: 'Single sign-on', hint: 'Inloggning med ert företagskonto.' },
        onboarding_templates: { title: 'Introduktionsmallar', hint: 'Checklistor för nya kollegors första dagar.' },
        recruiting_options: { title: 'Alternativlistor', hint: 'Tilltal, avtalstyper och arbetsplatser som ert team väljer bland.' },
      },
    },
    greeting: { morning: 'God morgon', day: 'Hej', evening: 'God kväll' },
    // Datumraden under hälsningen ("Måndag 21 september · Vecka 39",
    // workspace-start M2) ersätter den statiska underrubriken.
    dateLine: { week: 'Vecka {n}' },
    open: 'Öppna',
    recents: 'Senaste',
    recentKinds: { report: 'Veckorapport', job: 'Tjänst', application: 'Ansökan' },
    moreActions: 'Fler åtgärder',
    clockedInSince: 'Instämplad sedan {time}',
    clockedOut: 'Utstämplad',
    clockOut: 'Stämpla ut',
    clockIn: 'Stämpla in',
    projectRunning: 'Projekttid pågår',
    projectRunningSince: 'Sedan {time}',
    startProject: 'Starta ett projekt',
    // The clock tile for a person freed from booking working time (issue 981): the sentence, then the way to a project.
    workTimeFree: 'Enligt ditt avtal bokar du bara projekttid, inte arbetstid.',
    // The Stempeluhr's project choice once clocked in (Zeit's "Woran arbeitest du?"): the tile's field and its sheet.
    clockProject: {
      title: 'Vad jobbar du med?',
      none: 'Utan projekt',
      noneSub: 'Räknas som ”Ej tilldelad”',
      choose: 'Välj projekt och aktivitet',
      fieldLabel: 'Vad jobbar du med? Nu: {current}',
      runningWith: '{activity} · sedan {time}',
      runningSince: 'Sedan {time}',
      activityStep: 'Vilken aktivitet?',
      back: 'Alla projekt',
      defaultActivity: 'Standard',
      search: 'Sök projekt',
      noMatch: 'Inget projekt hittades',
      close: 'Stäng',
    },
    provisioning: 'Konfigureras — det kan ta en minut.',
    preferences: 'Inställningar',
    seeMyOrg: 'Min organisation',
    // What each module Lumi still sells actually does (issue 261 M2). Longer than the
    // launcher's one-liners (app-kit's `lumiModules.<key>.description`): this is one
    // app, so the home can say it in the module's own vocabulary.
    teaser: {
      about: {
        ats: 'Jobbannonser, ansökningar och rekryteringsflödet — från första cv:t till påskrivet avtal.',
        time_tracking: 'Stämpling, arbetstidssaldon, frånvaro och övertid, redo för arbetstidsregistreringen.',
        apprenticeship: 'Digitala utbildningsböcker, utbildningsplaner och omdömen för varje lärling.',
      },
      heading: 'Fler moduler',
    },
    empty: 'Här finns inget än – öppna modulen för att komma igång.',
    unavailable: 'Kan inte laddas just nu.',

    goToModule: 'Gå till {module}', expand: 'Expandera {module}', collapse: 'Fäll ihop {module}',
    themeLight: 'Ljust',
    themeDark: 'Mörkt',
    people: { selfService: 'Mina uppgifter' },
    myDocuments: {
      title: 'Mina dokument',
      downloadFailed: 'Nedladdningen misslyckades – försök igen senare.',
      showAll: 'Visa alla ({count})',
      showLess: 'Visa färre',
      handIn: 'Lämna in ett dokument',
      empty: 'Inget här ännu. Du kan lämna in ett betyg, ett intyg, ett läkarintyg eller en kopia av din legitimation till din akt.',
      kindLabel: 'Vad är det?',
      fileLabel: 'Fil – välj eller fotografera',
      send: 'Skicka',
      cancel: 'Avbryt',
      handedIn: 'Inlämnat {date} · väntar på HR',
      accepted: 'Inlämnat {date} · godkänt',
      sentBack: 'Skickat tillbaka {date}: ”{reason}”',
      handInAgain: 'Lämna in igen',
      dismiss: 'Dölj',
      error: {
        file_refused: 'Filen kunde inte godtas – försök med en annan fil.',
        file_too_large: 'Filen är för stor – gränsen är 25 MB.',
        file_empty: 'Filen är tom – välj en annan fil.',
        file_missing: 'Välj först en fil.',
        quota_exceeded: 'Din akt har nått sin lagringsgräns – kontakta HR.',
        invalid_category: 'Välj vilken sorts dokument det är.',
        not_possible: 'Det går inte att lämna in just nu – kontakta HR.',
        generic: 'Inlämningen misslyckades – försök igen senare.',
        scan_unavailable: 'Filen kunde inte kontrolleras just nu. Försök igen om en stund.',
      },
      category: {
        contract: 'Anställningsavtal',
        contract_amendment: 'Avtalsändring',
        certificate: 'Arbetsintyg / betyg',
        attestation: 'Intyg',
        payslip: 'Lönebesked',
        health_certificate: 'Sjukanmälan / läkarintyg',
        identification: 'Legitimation',
        other: 'Övrigt',
      },
    },
    admin: {
      users: 'Användare',
      usersMoved: {
        title: 'Användarhanteringen har flyttat till Personal',
        redirecting: 'Personal öppnas…',
        noPeople: 'Vem som har åtkomst till den här arbetsytan hanteras på varje person i Personal. Personal är inte tillgängligt för dig här – kontakta arbetsytans ägare.',
      },
    },
    verwaltung: { heading: 'Förvaltning' },
    nav: { home: 'Översikt', billing: 'Fakturering', logout: 'Logga ut', language: 'Språk', administration: 'Administration', sso: 'Single Sign-On', audit: 'Granskningslogg', supportAccess: 'Supportåtkomst', aiUsage: 'AI-användning', dataProcessing: 'Databehandling', dataRequests: 'Begäranden från registrerade', legalNotices: 'Juridiska meddelanden', statutoryRules: 'Lagregler', trainingOccupations: 'Utbildningsyrken', externalAgents: 'Externa AI-agenter', setup: 'Ställ in' },
    // The running week against its Sollstunden (#403). `hoursUnit` is a
    // separate key because the figures are formatted with Intl and the unit
    // trails them in every language this app ships.
    week: {
      title: 'Den här veckan',
      hoursUnit: 'tim',
      balance: 'Tidsbank, per {date}: {balance}',
      balanceHint: 'Arbetade timmar minus skyldiga timmar till och med den dagen.',
      noTarget: 'Ingen veckoarbetstid angiven.',
      trustBased: 'Du arbetar med förtroendearbetstid: du registrerar när du börjar och slutar, och för dig finns varken något mål eller någon tidsbank.',
      projectsMore: 'och {n} till',
      days: 'Veckans dagar',
    },
    heute: {
      clock: 'Stämpelklocka',
      attention: 'Behöver dig',
      news: 'Nytt',
      leaveRemaining: 'Kvarvarande semester',
      days: 'Dag | Dagar',
      kind: { interview: 'Intervju', leave: 'Frånvaro', holiday: 'Helgdag', exam: 'Prov', station: 'Avdelningsbyte' },
    },
    facts: {
      ats: { total_jobs: 'Tjänster', total_applications: 'Ansökningar', open_tasks: 'Öppna uppgifter', new_applicants: 'Nya kandidater', create_job: 'Skapa tjänst', add_application: 'Lägg till ansökan', create_task: 'Skapa uppgift', pipeline: 'Pipeline', pipeline_closed: '{n} avslutade', stage_other: 'Övriga' },
      time: { week_hours: 'Timmar denna vecka', today_hours: 'Timmar idag', timesheet: 'Min tidrapport', request_leave: 'Ansök om ledighet', approvals: 'Godkännanden', team: 'Team', pending_approvals: 'Väntande godkännanden', leave_remaining: 'Kvarvarande semester', proof_open: 'Underlag saknas' },
      apprentice: { waiting: 'Att granska', active: 'Lärlingar', overdue: 'Saknade veckor', this_week: 'Denna vecka', badges: 'Färdigheter', write: 'Fyll i veckan', skills: 'Färdighetsvägg', review: 'Granska rapporter', onboard: 'Lägg till lärling', reports: 'Rapportböcker', report_approved: 'Godkända', report_submitted: 'Att granska', report_rejected: 'Återsända', report_missing: 'Saknas' },
    },
  },
  preferences: {
    appearance: 'Utseende',
    theme: 'Tema',
    themeHint: 'Ljust eller mörkt gränssnitt.',
    language: 'Språk',
    languageHint: 'Språket i hela arbetsytan.',
    attributions: 'Erkännanden för öppna data',
    placesCredit: 'Platsdata © {source}, licensierad under {licence}.',
    bankCodesCredit: "Bankkoder: källa {bundesbank}; österrikiska bankkoder © {oenb}, licensierade under {licence}; schweiziska och liechtensteinska bankkoder © {six}.",
    healthInsurersCredit: "Sjukförsäkringskassor: socialförsäkringens stamdatafil från {gkv}.",
  },
  onboarding: {
    actions: { add: 'Lägg till', back: 'Tillbaka', next: 'Nästa', remove: 'Ta bort' },
    modules: {
      ats: 'Rekrytering',
      time_tracking: 'Tid',
      apprenticeship: 'Ausbildung',
    },
    fork: {
      // The headline is two keys: the lead and `titleMark`, the final beat that sits
      // on the highlighter stroke. The mark is always the LAST beat of the sentence.
      eyebrow: 'Välkommen till lumi',
      title: 'Vad roligt att du',
      titleMark: 'är här.',
      subtitle: 'Hur vill du börja? Du kan byta när som helst.',
      // From a live demo the same page is the way out of it.
      eyebrowDemo: 'Ut ur demon',
      titleDemo: 'Nog med utforskande.',
      titleDemoMark: 'Nu på riktigt.',
      subtitleDemo: 'Med den guidade konfigurationen finns demoföretaget kvar tills du är klar.',
      reassure: 'Osäker? Börja med demon – till den riktiga konfigurationen byter du när du vill.',
      seedFailed: 'Förberedelsen av demodata slutfördes inte. Försök igen.',
      seedFailedNotEmpty:
        'Demot kräver tomma moduler, men en av dina innehåller redan data. Ta bort dem först, eller välj ”Konfigurera din svit” i stället.',
      // #364 F19: why the fork opened mid-Finish. The wizard hands an admin back
      // here when the AVV is still unsigned; landing with nothing said is what
      // made a refused Finish read as a silent drop.
      avvRequiredNotice:
        'Konfigurationen kan inte slutföras förrän personuppgiftsbiträdesavtalet (AVV) har accepterats. Acceptera det här, så kommer du direkt tillbaka till konfigurationsguiden.',
      // #364 F21 / ADR 0032 Decision 2: the fork is now also reached FROM a live
      // demo, so it needs the wizard's way out. Leaving costs nothing.
      backToDemo: 'Tillbaka till demot',
      demo: {
        eyebrow: 'Prova',
        title: 'Utforska med demodata',
        body: 'Vi fyller dina moduler med ett sammanhängande, fiktivt företag. Klicka runt i allt utan att förstöra något.',
        modulesHint: 'Bokade moduler är alltid med.',
        cta: 'Utforska demot',
      },
      guided: {
        eyebrow: 'Konfigurera',
        title: 'Guida mig steg för steg',
        body: 'Steg för steg till din riktiga svit. Pausa, hoppa över eller gå först till demot – allt går.',
        bodyDemo: 'Steg för steg till din riktiga svit. Stänger du fönstret är du tillbaka i demot.',
        pointSaved: 'Dina framsteg sparas',
        pointOptional: 'Varje steg är valfritt',
        cta: 'Guida mig',
      },
      empty: {
        eyebrow: 'Gör det själv',
        titleFresh: 'Börja tomt',
        titleDemo: 'Förkasta demot och börja tomt',
        bodyFresh: 'En tom yta. Du konfigurerar allt efter hand, precis i din egen takt.',
        bodyDemo: 'Demoföretaget raderas och du börjar på en tom bas.',
        warnDemo: 'Det sker direkt och går inte att ångra.',
        cta: 'Börja tomt',
      },
    },
    exitGate: {
      title: 'Innan du lämnar demon',
      intro: 'Det här har din arbetsyta bokat, och så här ligger din provperiod. Lägg till en modul nu eller senare under Fakturering — konfigurationen fungerar oavsett.',
      booked: { title: 'Bokat' },
      // The colleagues invited from the demo bar, named before the owner ends the demo
      // (issue 669); `fallback` stands in when the roster could not be read.
      guests: {
        title: 'Kollegor du bjudit in till demon',
        lead: 'De här kollegorna förlorar åtkomsten när demon avslutas:',
        fallback: 'Kollegor du bjudit in till demon förlorar åtkomsten när den avslutas.',
        people: 'Ditt riktiga team bjuder du in från Personal när din arbetsyta är konfigurerad.',
      },
      // What only the gate can say about a module booked at it (#409 F12): whether
      // its setup-guide section is there yet. The booking rows themselves are the
      // billing section's.
      bookedHere: {
        settingUp: 'Förbereder {module}…',
        booked: '{module} är bokad och har ett eget avsnitt i konfigurationsguiden.',
        bookedPending: '{module} är bokad. Avsnittet visas i konfigurationsguiden så snart modulen är klar.',
      },
      noManage: 'Bara arbetsytans ägare, en faktureringsansvarig eller en arbetsyteadministratör kan boka moduler. Du kan ändå fortsätta utan att boka.',
      enforcement: 'Det finns en obetald betalning för den här arbetsytan. Bokningar är pausade tills den är reglerad — men inte konfigurationen av din suite.',
      factsUnavailable: 'Vi kunde inte läsa in din bokning just nu. Du kan ändå fortsätta; allt finns på sidan Fakturering.',
      trial: {
        title: 'Din provperiod',
        range: 'Din provperiod började {start} och slutar {end}.',
        endOnly: 'Din provperiod slutar {end}.',
        rangeFree: 'Utan kostnad från {start} till {end}.',
        endOnlyFree: 'Utan kostnad till {end}.',
        charge: 'Från {end} debiteras {amount} per månad för det du har bokat, i början av varje faktureringsmånad.',
        chargeNoTotal: 'Från {end} debiteras din bokning månadsvis, i början av varje faktureringsmånad.',
        firstCharge: 'Den första debiteringen sker {date}.',
        demoCounted: 'Tiden du tillbringade i demon räknades in i din provperiod.',
        over: 'Din provperiod är slut och din bokning faktureras månadsvis.',
        monthly: 'Det är {amount} per månad.',
        nextCharge: 'Nästa debitering sker {date}.',
      },
      continue: 'Fortsätt till konfigurationen',
    },
    avv: {
      modalTitle: 'Acceptera personuppgiftsbiträdesavtalet (AVV)',
      modalBody:
        'Att konfigurera din svit med riktiga data innebär att lumi behandlar personuppgifter för din räkning. Innan du fortsätter, läs och acceptera vårt aktuella personuppgiftsbiträdesavtal (AVV).',
      modalLinkText: 'Läs hela AVV',
      modalCheckboxLabel: 'Jag har läst och accepterar det aktuella AVV-avtalet.',
      modalCancel: 'Inte än',
      modalAccept: 'Acceptera och fortsätt',
    },
    preparing: {
      first: {
        title: 'Din demo förbereds.',
        body: 'Vi skapar ett sammanhängande, fiktivt företag i alla dina moduler. Det tar bara ett ögonblick.',
      },
      reset: {
        title: 'Din demo återställs.',
        body: 'Vi tömmer demoföretaget och bygger upp det igen från början. Din arbetsyta och dina kollegor påverkas inte. Det tar bara ett ögonblick.',
      },
      stuck: {
        note: 'Det här tar längre tid än väntat.',
        cta: 'Konfigurera manuellt i stället',
      },
    },
    nonAdmin: {
      title: 'Nästan',
      titleMark: 'klart.',
      body: 'Din administratör konfigurerar fortfarande sviten. Så fort det är klart kommer du direkt in här.',
    },
    wizard: {
      title: 'Konfigurera din svit',
      subtitle: 'Allt här är valfritt och dina ändringar sparas. Ställ in det du vill, slutför konfigurationen eller gå tillbaka till demon genom att stänga det här fönstret.',
      subtitleCommitting: 'Din konfiguration tillämpas. Om ett steg misslyckas kan du hoppa över det och ställa in det senare i inställningarna.',
      crossRef: 'Används i {modules} — ändra det senare i {owner}.',
      crossRefOwnerDefault: 'Personal',
      recovery: '”{step}” kunde inte tillämpas. Kontrollera dina uppgifter där och slutför igen.',
      details: {
        step: 'Dina uppgifter',
        title: 'Dina uppgifter',
        subtitle: 'Din egen post i Personal. Kontrollera ditt namn – när du sparar bekräftar du din post.',
        loading: 'Din post läses in…',
        confirmed: 'Din post är bekräftad som {name}. Du kan ändra den senare i Personal.',
        unavailable: 'Din post kunde inte läsas in just nu. Du kan bekräfta den senare i Personal.',
        firstName: 'Förnamn',
        lastName: 'Efternamn',
        required: 'Ange ditt för- och efternamn.',
        hq: {
          title: 'Ert huvudkontor',
          why: 'Lumi klarar sig inte utan en plats: det behöver ert huvudkontor som första plats, till exempel för era jobbannonser.',
          street: 'Gata',
          postalCode: 'Postnummer',
          city: 'Ort',
          country: 'Land',
          countryNone: 'Inget land valt',
          required: 'Ange gata, postnummer, ort och land för ert huvudkontor.',
        },
      },
      general: {
        title: 'Allmänt',
        company: {
          title: 'Företagsprofil',
        },
        name: {
          label: 'Företagsnamn',
          hint: 'Förifyllt från kassan — ändra vid behov. Obligatoriskt.',
          required: 'Företagsnamn är obligatoriskt.',
        },
        profile: {
          industry: 'Bransch',
          employeeCountRange: 'Företagsstorlek',
          employeeCountPlaceholder: 't.ex. 50–200',
          foundedYear: 'Grundat',
          foundedYearPlaceholder: 't.ex. 2010',
          legalForm: 'Bolagsform',
          websiteUrl: 'Webbplats',
        },
        place: {
          hint: 'Välj en ort i listan som namn på platsen — eller skriv ett eget namn och bekräfta med Enter eller +.',
        },
        org: {
          title: 'Organisationsstruktur',
          subtitle: 'Avdelningar, platser och kostnadsställen som dina medarbetare tillhör.',
          departments: 'Avdelningar',
          locations: 'Platser',
          costCenters: 'Kostnadsställen',
          empty: 'Inga ännu',
          addDepartment: 'Ny avdelning',
          addLocation: 'Ny plats, t.ex. Stockholm',
          addCostCenter: 'Nytt kostnadsställe',
        },
      },
      finish: {
        cta: 'Slutför konfigurationen',
        step: 'Slutför',
        title: 'Slutför din konfiguration',
        body: 'När du slutför tillämpas dina svar. Du kan ändra allt senare i varje modul.',
        nextTitle: 'Nästa: bjud in ditt team',
        nextBody: 'Efter konfigurationen öppnar du administrationsområdet för att bjuda in de första användarna och tilldela deras roller.',
        demoWarning: 'När du slutför raderas demoföretaget och alla användare som bjudits in medan du utforskade det.',
      },
      sections: {
        ats: {
          title: 'Rekrytering',
          subtitle: 'Ställ in hur ansökningar och rekryterings-e-post fungerar.',
          fields: {
            fromName: { label: 'Avsändarnamn', hint: 'Visas i e-post till kandidater.' },
            signature: { label: 'E-postsignatur', hint: 'Läggs till i utgående kandidat-e-post.' },
          },
          jobPosting: {
            title: 'Jobbannons',
            hint: 'Kandidatkontakten och logotypen som visas i externa jobbannonser (valfritt — du kan också ställa in detta senare).',
            contactName: 'Kontaktnamn',
            contactEmail: 'Kontakt-e-post',
            logo: 'Annonslogotyp',
            uploadLogo: 'Ladda upp logotyp',
            removeLogo: 'Ta bort',
            rePick: 'Din logotyp har inte laddats upp än — välj den igen.',
            contactEmailInvalid: 'Ange en giltig e-postadress.',
          },
          workflow: {
            title: 'Rekryteringsflöde',
            participantsQuestion: 'Vem är involverad i jobbannonser och ansökningar?',
            worksCouncil: 'Företagsråd',
            sbv: 'Representation för medarbetare med funktionsnedsättning',
            legalSignOff: 'Juridik – godkänner en jobbannons innan den publiceras',
            assessmentCentreQuestion: 'Använder ni assessment center?',
            assessmentCentre: 'Ja, vi använder assessment center',
            hint: 'Du kan redigera och uppdatera processen när som helst, senare, i ATS.',
          },
        },
        time_tracking: {
          title: 'Tid',
          subtitle: 'Bokningstyper och arbetstidsregler.',
          fields: {
            bookingTypes: { label: 'Bokningstyper', hint: 'Lägg till de bokningstyper du använder.', placeholder: 't.ex. Arbete' },
          },
          companyHolidays: {
            title: 'Företagsstängda dagar',
            hint: 'Dagar då företaget har stängt – till exempel en halvdag på julafton och nyårsafton. De dagarna räknas inga måltimmar. För varje post bestämmer du om den dras från semestern; det kan du ändra senare i inställningarna för Tid.',
            empty: 'Inga företagsstängda dagar har lagts in än.',
            suggestions: 'Förslag:',
            christmasEve: 'Julafton',
            newYearsEve: 'Nyårsafton',
            name: 'Benämning',
            namePlaceholder: 't.ex. Mellandagarna',
            from: 'Från',
            to: 'Till (valfritt)',
            halfDay: 'Halvdag',
            yearly: 'Varje år',
            deductsFromLeave: 'Dra från semestern',
            rangeReversed: 'Slutdatumet ligger före startdatumet.',
          },
        },
        apprenticeship: {
          title: 'Ausbildung',
          subtitle: 'Utbildningsyrken.',
          fields: {
            professions: { label: 'Utbildningsyrken', hint: 'Lärlingsyrkena du utbildar i.', placeholder: 't.ex. IT-tekniker' },
          },
        },
        people: {
          title: 'Personal',
          subtitle: 'Gemensam terminologi som används i hela sviten.',
          fields: {
            salutations: { label: 'Tilltal', hint: 'Lägg till tilltal utöver standarduppsättningen.', placeholder: 't.ex. Mx' },
            contractTypes: { label: 'Anställningsformer', hint: 'Lägg till anställningsformer utöver standarduppsättningen.', placeholder: 't.ex. Extraarbetande student' },
            workTimeModels: { label: 'Arbetstidsmodeller', hint: 'Lägg till modeller utöver standarduppsättningen.', placeholder: 't.ex. Delad tjänst' },
            workLocationTypes: { label: 'Arbetsplatser', hint: 'Lägg till typer av arbetsplats utöver standarduppsättningen.', placeholder: 't.ex. Fältarbete' },
          },
        },
      },
    },
    commit: {
      wiping: {
        title: 'Rensar demot…',
        body: 'Tar bort demoföretaget så att din riktiga konfiguration börjar rent.',
      },
      applying: {
        title: 'Konfigurerar din svit…',
        body: 'Tillämpar dina svar. Det tar bara ett ögonblick.',
      },
      steps: {
        company: 'Företagsprofil',
      },
      error: 'Något gick fel när din konfiguration tillämpades.',
      retry: 'Försök igen',
      backToSetup: 'Tillbaka till konfigurationen',
      skipStep: 'Slutför utan det här steget',
      skipped: 'Överhoppat: {steps}. Du kan ställa in det när som helst i inställningarna.',
      resume: 'Återuppta konfigurationen',
      stalled: 'Det här tar längre tid än väntat.',
      wipeFailed: 'Det gick inte att rensa demot. Försök igen för att fortsätta.',
      logoMissing: 'Din logotyp laddades inte upp (försvann vid omladdning) — du kan lägga till den senare i inställningarna för jobbannonser.',
      workflowFailed: 'Din rekryteringskedja kunde inte genereras, så din arbetsyta börjar med standardkedjan. Allt annat tillämpades — öppna workflow-inställningarna i Rekrytering för att köra generatorn igen.',
      workflowDrafted: "Din rekryteringsprocess sparades som utkast eftersom {roles} ännu inte har någon tilldelad. Öppna workflow-inställningarna i Rekrytering för att aktivera den när rollen är bemannad.",
      workflowRoles: {
        ats_works_council: "företagsrådet",
        ats_sbv: "representationen för medarbetare med funktionsnedsättning",
        ats_legal: "juridikavdelningen",
      },
      continue: 'Fortsätt till arbetsytan',
    },
  },
  tenants: {
    switcherLabel: 'Byt arbetsyta',
    supportAccessBadge: 'Support',
    supportAccessUntil: 'Tillfällig supportåtkomst till {until}',
    supportAccessBanner: 'lumi-supporten har för närvarande tillfällig åtkomst till den här arbetsytan.',
    supportAccessReview: 'Granska',
  },
  dataProtection: {
    blockedErasure: {
      title: 'Vad som blockerar en radering',
      intro: 'Personaldokument utan lagringstid sparas tills vidare: ingen har avgjort hur länge de måste sparas, och ett oavgjort dokument raderas aldrig automatiskt. Här ser du dem, så att tiderna kan sättas.',
      sensitivePlaceholder: 'Känsligt dokument',
      categories: {
        contract: 'Avtal',
        contract_amendment: 'Avtalsändring',
        certificate: 'Intyg',
        attestation: 'Bekräftelse',
        warning: 'Varning',
        other: 'Övrigt dokument',
      },
      outcomes: {
        refused: 'Radering nekad',
        partial: 'Delvis raderat',
      },
      list: {
        title: 'Dokument utan lagringstid',
        fixHint: 'De äldsta visas först. Sätt en lagringstid på dokumentet i personalakten så försvinner det från listan.',
        loading: 'Hämtar dokument…',
        loadError: 'Listan kunde inte hämtas. Försök igen — läs det inte som ”inget hittat”.',
        empty: 'Alla dokument i den här arbetsytan har en lagringstid.',
        uploadedLabel: 'Uppladdat',
        truncated: 'Endast de {count} äldsta dokumenten visas. Fler väntar på en lagringstid.',
      },
    },
    myData: {
      title: 'Mina uppgifter',
      intro: 'Här kan du fråga vilka uppgifter den här arbetsytan har om dig, be om rättelse eller begära radering. Varje begäran registreras och besvaras av de personer som ansvarar för dataskydd i arbetsytan, och du kan följa den här.',
      requests: {
        title: 'Mina begäranden',
        loading: 'Dina begäranden laddas…',
        loadError: 'Dina begäranden kunde inte laddas. Du kan ändå skicka en begäran nedan.',
        empty: 'Du har inte skickat någon begäran ännu.',
        filedLabel: 'Skickad',
        dueLabel: 'Svar senast',
        outcomeLabel: 'Resultat',
        awaitingRelease: 'Kopian granskas',
      },
      kinds: {
        access: 'Kopia av mina uppgifter',
        rectification: 'Rättelse',
        erasure: 'Radering',
      },
      statuses: {
        received: 'Mottagen',
        verifying: 'Din identitet kontrolleras',
        in_progress: 'Under handläggning',
        awaiting_subject: 'Väntar på ditt svar',
        completed: 'Avslutad',
        refused: 'Avslagen',
        withdrawn: 'Återkallad',
      },
      outcomes: {
        erased: 'Uppgifter raderade',
        suppressed: 'Uppgifter raderade, minimal notering kvar',
        refused: 'Avslagen',
        partial: 'Delvis genomförd',
        answered: 'Besvarad',
      },
      actions: {
        access: {
          title: 'Be om en kopia av mina uppgifter',
          body: 'Du kan be om en kopia av de uppgifter som den här arbetsytan har om dig. Det är ingen direkt nedladdning: kopian sammanställs först, och du får veta när den är klar.',
          where: 'En färdig kopia skickas aldrig som bilaga i e-post. Du får ett mejl, loggar in på ditt lumi HR-konto och laddar ner den där.',
          cta: 'Be om en kopia',
          detailLabel: 'Något du vill tillägga (valfritt)',
          detailHint: 'Till exempel om du bara vill ha en del av dina uppgifter.',
        },
        rectification: {
          title: 'Be om rättelse',
          body: 'Om något som arbetsytan har om dig är fel eller inaktuellt kan du be om att det rättas.',
          cta: 'Be om rättelse',
          detailLabel: 'Vad är fel, och vad ska det stå?',
          detailHint: 'Beskriv uppgifterna så exakt du kan, så att de går att hitta och kontrollera.',
          selfTitle: 'En del ändrar du själv',
          selfFields: 'Ditt namn och din tilltalsform, ditt kön, din kontaktmejl, ditt telefonnummer, din adress, ditt medborgarskap, ditt civilstånd och ditt språk ändrar du själv i din profil.',
          selfLink: 'Öppna min profil',
          askBody: 'För allt annat – födelsedatum, anställningsnummer, avtals-, löne- eller skatteuppgifter, dina dokument – använd begäran nedan.',
        },
        erasure: {
          title: 'Begära att mina uppgifter raderas',
          body: 'Du kan be arbetsytan att radera de uppgifter den har om dig.',
          cta: 'Begär radering',
          confirm: 'Din begäran prövas av de ansvariga i arbetsytan. Uppgifter som måste sparas enligt lag, eller som fortfarande behövs för din anställning, kan inte raderas. Du får veta vad som raderades och vad som sparas.',
          detailLabel: 'Något du vill tillägga (valfritt)',
          detailHint: 'Till exempel vilka uppgifter du menar, om det inte gäller alla.',
        },
      },
      form: {
        submit: 'Skicka begäran',
        submitting: 'Skickar…',
        cancel: 'Avbryt',
        success: 'Din begäran är registrerad. Du hittar den ovan under ”Mina begäranden”.',
        errorGeneric: 'Din begäran kunde inte skickas. Ingenting registrerades – försök igen.',
        errorRateLimit: 'Du har skickat flera begäranden på kort tid. Försök igen senare.',
      },
    },
    export: {
      title: 'Exportera den här arbetsytan',
      intro: 'Du kan när som helst ladda ner en fullständig kopia av allt som den här arbetsytan sparar, i maskinläsbar form och utan att fråga oss.',
      contents: {
        title: 'Vad filen innehåller',
        body: 'Arkivet innehåller alla personers uppgifter i klartext och dessutom arbetsytans aktiva åtkomstnycklar: AI-nyckeln, kalenderlänkar med tillhörande tokens och inloggningsuppgifterna till anslutna leverantörer. Arkivet innehåller också, för Personal, Rekrytering och Tid, ett HR Open Standards-dokument (HR-JSON) — det delade formatet om du byter leverantör.',
        handling: 'Förvara det lika omsorgsfullt som nycklarna själva. Den som får tag på filen och lösenordet har allt som finns i den.',
      },
      roleRequired: {
        title: 'Den här exporten kräver rollen ”Dataskydd”',
        body: 'Arkivet innehåller varje fil som finns i den här arbetsytan — lönebesked, läkarintyg och identitetshandlingar bland dem — vid sidan av allas personuppgifter och arbetsytans aktiva åtkomstnycklar.',
        hint: 'Att äga arbetsytan räcker inte längre: den som startar exporten måste dessutom ha rollen ”Dataskydd”. Rollen tilldelas tillsammans med de övriga sviterollerna i användaradministrationen, och den kan tilldelas dig.',
      },
      start: {
        title: 'Starta en export',
        body: 'Välj ett lösenord. Arkivet krypteras med det, och bara med det går det att öppna.',
        passphraseWarning: 'Vi sparar aldrig ditt lösenord och kan inte återskapa det. Om du tappar bort det går arkivet inte längre att öppna — det finns ingen återställning.',
        passphraseLabel: 'Lösenord',
        passphraseHint: 'Minst {min} tecken. Välj något långt som du kan förvara säkert.',
        confirmLabel: 'Upprepa lösenordet',
        submit: 'Starta export',
        submitting: 'Startar…',
        success: 'Exporten har startats. Den skapas i bakgrunden och dyker upp nedan när den är klar.',
        errorTooShort: 'Lösenordet behöver minst {min} tecken.',
        errorMismatch: 'De två lösenorden stämmer inte överens.',
        errorAlreadyRunning: 'En export av den här arbetsytan pågår redan. Vänta tills den är klar innan du startar en ny.',
        errorTooMany: 'Den här arbetsytan har tills vidare startat det högsta antalet exporter. Försök igen senare.',
        errorGeneric: 'Vi kunde inte bekräfta att exporten startade. Kontrollera listan nedan innan du startar en till.',
      },
      list: {
        title: 'Exporter av den här arbetsytan',
        loading: 'Laddar exporter…',
        loadError: 'Exporterna kunde inte laddas.',
        empty: 'Den här arbetsytan har inte exporterats än.',
        linkHint: 'En nedladdningslänk gäller bara en kort stund. Om den slutar fungera använder du knappen igen.',
        retentionHint: 'Varje arkiv raderas automatiskt när det går ut — datumet står bredvid.',
        startedLabel: 'Startad',
        expiresLabel: 'Tillgänglig till',
        download: 'Ladda ner',
        preparing: 'Förbereder…',
        downloadError: 'Nedladdningen kunde inte förberedas. Arkivet finns kanske inte kvar.',
        gone: 'Arkivet har raderats. Starta en ny export om du behöver en till kopia.',
        failedHint: 'Den här exporten blev inte klar. Du kan starta en ny.',
        runningHint: 'Den här exporten skapas fortfarande.',
      },
      statuses: {
        requested: 'Begärd',
        exporting: 'Skapas',
        exported: 'Klar',
        failed: 'Misslyckad',
        expired: 'Raderad',
      },
    },
    settingsPanel: {
      title: 'Databehandling',
      body: 'Du kan be om att dina uppgifter raderas eller rättas, eller begära en kopia, {link}.',
      linkLabel: 'här',
    },
  },
  // Administration › Data subject requests (issue 789): the DSAR work list.
  dataRequests: {
    forbidden: {
      title: 'Den här listan är för dataskyddsrollen',
      description: 'Begäranden från registrerade hanteras av arbetsytans ägare eller av den som har rollen ”Dataskydd”.',
    },
    intro: {
      title: 'Begäranden från registrerade',
      body: 'Begäranden från personer om de uppgifter den här arbetsytan har om dem. Varje begäran ska besvaras inom en månad från mottagandet (art. 12.3 i GDPR). Är begäran komplex kan fristen förlängas två gånger med en månad — med ett skäl som personen ska få veta.',
    },
    filters: {
      label: 'Visa begäranden',
      open: 'Öppna',
      overdue: 'Försenade',
      dueSoon: 'Inom 7 dagar',
      closed: 'Nyligen besvarade',
    },
    empty: {
      title: 'Inga begäranden från registrerade',
      description: 'När någon frågar om sina uppgifter — i lumi, via e-post, post eller telefon — visas begäran här med sin frist.',
    },
    emptyFilter: 'Inga begäranden i den här vyn.',
    truncated: 'Alla begäranden får inte plats på den här sidan. De närmaste fristerna visas först.',
    badges: {
      overdue: 'Försenad',
      dueSoon: 'Snart förfallen',
      legalHold: 'Bevarandekrav',
      reviewReady: 'Redo för granskning',
      reviewReleased: 'Frisläppt',
      reviewDelivered: 'Levererad',
    },
    row: {
      received: 'Mottagen',
      due: 'Svar senast',
      closed: 'Avslutad',
      subject: 'Gäller',
      channel: 'Kom in via',
      outcome: 'Resultat',
      extensions: 'Fristen förlängd {count} av 2 gånger',
      postponed: 'Påminnelser pausade till {date}',
      vetoWindow: 'Raderingen kan fortfarande stoppas till {date}',
      reviewFlagged: 'Ditt beslut behövs: {flagged} av {total} poster',
      reviewNoneFlagged: 'Inga poster markerade',
      reviewEmpty: 'Kopian innehåller inga poster',
      reviewOpen: 'Granska',
      reviewReleased: 'Frisläppt, levereras',
      reviewDelivered: 'Levererad, avslutas',
    },
    legalHold: {
      tenant: 'Ett bevarandekrav gäller hela arbetsytan ({reason}).',
      subject: 'Ett bevarandekrav omfattar den här personen ({reason}).',
      consequence: 'Uppgifterna får inte raderas. Det lagliga svaret är ett avslag som namnger just den grunden — kravet skjuter inte upp fristen.',
    },
    automated: {
      pending: 'lumi besvarar den här begäran själv: när du har kontrollerat personens identitet och satt begäran till ”Under arbete” sammanställer lumi kopian av uppgifterna. Den väntar sedan på din granskning. När du har frisläppt den får personen veta var den kan laddas ned, och begäran avslutas av sig själv.',
      running: 'lumi sammanställer just nu kopian av den här personens uppgifter. Den väntar sedan på din granskning – personen får veta var den kan laddas ned först när du har frisläppt den.',
    },
    detail: {
      show: 'Visa vem som frågade',
      hide: 'Dölj detaljer',
      loading: 'Laddar detaljer…',
      loadError: 'Detaljerna för den här begäran kunde inte laddas.',
      subjectLabel: 'Angivet namn',
      subjectEmail: 'E-postadress',
      subjectPhone: 'Telefonnummer',
      requestDetail: 'Vad som efterfrågades',
      onBehalfReason: 'Registrerad för personens räkning eftersom',
      extensionReason: 'Skäl för förlängningen',
      outcomeBasis: 'Angiven grund',
      nothingOnFile: 'Kontakt',
      nothingOnFileValue: 'Inget namn, ingen adress och inget meddelande finns registrerat för den här begäran.',
    },
    kinds: {
      access: 'Kopia av sina uppgifter',
      rectification: 'Rättelse',
      erasure: 'Radering',
      restriction: 'Begränsning av behandlingen',
      portability: 'Dataportabilitet',
      objection: 'Invändning mot behandlingen',
    },
    statuses: {
      received: 'Mottagen',
      verifying: 'Identiteten kontrolleras',
      in_progress: 'Under arbete',
      awaiting_subject: 'Väntar på personen',
      completed: 'Klar',
      refused: 'Avslagen',
      withdrawn: 'Återkallad',
    },
    outcomes: {
      erased: 'Uppgifter raderade',
      suppressed: 'Uppgifter raderade, minimal post kvar',
      refused: 'Avslagen',
      partial: 'Delvis utförd',
      answered: 'Fullständigt besvarad',
    },
    subjectTypes: {
      person: 'En personalakt',
      tenant_user: 'En medlem utan personalakt',
      candidate: 'En sökande',
      unlinked: 'Inte kopplad till någon post',
    },
    channels: {
      'self-service': 'Inlämnad i lumi av personen',
      'candidate-portal': 'Kandidatportalen',
      email: 'E-post',
      post: 'Brev',
      phone: 'Telefon',
      unknown: 'Inte registrerat',
    },
    actions: {
      advance: {
        verifying: 'Kontrollera identiteten',
        in_progress: 'Börja arbeta med den',
        awaiting_subject: 'Vänta på personen',
      },
      extend: 'Förläng fristen',
      close: 'Avsluta begäran',
      postpone: 'Pausa påminnelser',
      veto: 'Öppna vetofrist',
      hold: 'Bevarandekrav för personen',
      restrict: 'Begränsa behandlingen',
      record: 'Registrera en begäran',
    },
    confirmAutomated: {
      title: 'Sammanställa kopian av uppgifterna?',
      body: 'Med ”Under arbete” ger du lumi i uppdrag att samla allt den här arbetsytan har om personen. Kopian går inte till personen ännu: den väntar på din granskning, och personen får veta var den kan laddas ned först när du har frisläppt den. Gör det först när identiteten är fastställd.',
      confirm: 'Starta',
    },
    toast: {
      advanced: 'Begäran satt till ”{status}”.',
      extended: 'Fristen förlängd till {date}.',
      closed: 'Begäran avslutad.',
      postponed: 'Påminnelser pausade till {date}.',
      vetoOpened: 'Vetofristen är öppnad. Raderingen väntar 72 timmar.',
      holdPlaced: 'Bevarandekrav infört.',
      holdReleased: 'Bevarandekrav hävt.',
      holdAttested: 'Bevarandekrav bekräftat för ytterligare sex månader.',
      restrictionPlaced: 'Behandlingen begränsad.',
      restrictionNotified: 'Underrättelse registrerad.',
      restrictionLifted: 'Begränsningen hävd.',
      recorded: 'Begäran registrerad.',
    },
    extend: {
      title: 'Förläng fristen',
      body: 'Art. 12.3 i GDPR tillåter två förlängningar på en månad när en begäran är komplex eller de är många. Meddela personen inom den första månaden, med skälet.',
      remaining: 'Förlängningar kvar: {count}',
      reasonLabel: 'Skäl för förseningen',
      reasonHint: 'Sparas med begäran. Ge personen samma skäl.',
      submit: 'Förläng med en månad',
      errorReason: 'Ange skälet för förseningen.',
    },
    close: {
      title: 'Avsluta begäran',
      body: 'En avslutad begäran kan inte öppnas igen: den är beviset på hur och när arbetsytan svarade.',
      statusLabel: 'Hur avslutades den?',
      outcomeLabel: 'Vad gjordes',
      outcomePlaceholder: 'Välj…',
      basisLabel: 'Rättslig grund',
      basisHint: 'Grunden för det som behölls eller avslogs, t.ex. en lagringsplikt eller art. 12.5 i GDPR.',
      submit: 'Avsluta begäran',
      errorOutcome: 'Välj vad som gjordes.',
      errorBasis: 'Ett avslag eller ett delvis svar måste ange sin rättsliga grund.',
      conflict: 'Begäran kunde inte avslutas på det här sättet. Ett bevarandekrav eller ett öppet vetofönster kan blockera raderingen, eller så har begäran ändrats under tiden — ladda om listan och kontrollera.',
    },
    record: {
      title: 'Registrera en begäran',
      body: 'För en begäran som kom via e-post, brev eller telefon. Fristen på en månad löper från den dag den kom in, inte från i dag. En registrerad begäran börjar som mottagen.',
      choose: 'Välj…',
      kindLabel: 'Typ av begäran',
      channelLabel: 'Kom in via',
      receivedLabel: 'Mottagen den',
      receivedHint: 'Den dag begäran nådde arbetsytan — senast i dag.',
      subjectLabel: 'Berörd person',
      modes: {
        person: 'En person i Personal',
        candidate: 'En sökande i Rekrytering',
        unlinked: 'Inte registrerad',
      },
      personLabel: 'Sök person',
      personHint: 'Sök på namn eller e-postadress.',
      candidateLabel: 'Sökande',
      candidateHint: 'Sök på namn eller e-postadress. Bara sökande som din roll i Rekrytering får öppna hittas.',
      candidateRefused: 'Dina roller i Rekrytering tillåter inte sökning efter sökande. Välj ”Inte registrerad” och ange det namn personen uppgav.',
      searchPlaceholder: 'Namn eller e-postadress',
      picker: {
        searching: 'Söker…',
        typeMore: 'Minst {count} tecken',
        noMatch: 'Inga träffar. Om personen inte finns registrerad någonstans, välj ”Inte registrerad”.',
        error: 'Sökningen misslyckades. Om personen inte finns registrerad någonstans, välj ”Inte registrerad”.',
        refused: 'Dina roller tillåter inte sökning efter sökande.',
        rateLimited: 'För många sökningar – strax igen',
        resultsAnnouncement: 'En träff | {count} träffar',
        clear: 'Rensa urval',
      },
      nameLabel: 'Angivet namn',
      nameHint: 'Så som personen skrev under eller presenterade sig.',
      emailLabel: 'E-postadress (valfritt)',
      detailLabel: 'Vad begärs?',
      detailHint: 'Valfritt. Så långt som möjligt med personens egna ord.',
      reasonLabel: 'Varför registrerar du detta för personens räkning?',
      reasonHint: 'Till exempel: brev till HR den 3 maj, eller samtal som receptionen tog emot. Sparas med ditt namn.',
      submit: 'Registrera begäran',
      errorKind: 'Välj typ av begäran.',
      errorChannel: 'Välj hur begäran kom in.',
      errorReceived: 'Välj den dag begäran kom in.',
      errorFuture: 'En begäran kan inte komma in i framtiden. Välj i dag eller en tidigare dag.',
      errorPerson: 'Välj personen i sökningen, eller ”Inte registrerad”.',
      errorCandidate: 'Välj den sökande i sökningen, eller ”Inte registrerad”.',
      errorName: 'Ange det namn personen uppgav.',
      errorEmail: 'Ange en giltig e-postadress, eller lämna fältet tomt.',
      errorReason: 'Ange varför du registrerar begäran för personens räkning.',
    },
    errors: {
      conflict: 'Det här steget är inte längre möjligt — begäran har ändrats under tiden. Ladda om listan.',
      notLinked: 'Den här begäran är inte kopplad till någon post, så det finns ingen att bevara eller begränsa.',
    },
    progress: {
      title: 'Radering per modul',
      show: 'Visa raderingens förlopp',
      hide: 'Dölj raderingens förlopp',
      loading: 'Raderingsregistret läses in…',
      loadError: 'Raderingsregistret kunde inte läsas in.',
      unlinked: 'Den här begäran är inte kopplad till någon post, så ingen modul raderade något för den.',
      lastExecuted: 'registrerad {date}',
      states: {
        done: 'Raderad',
        heldNothing: 'Höll inget',
        pending: 'Inte registrerad än',
        deferred: 'Uppskjuten – modulen avaktiverad',
      },
      modules: {
        people: 'Personal',
        ats: 'Ansökningar',
        time: 'Tid',
        apprentice: 'Lärlingsutbildning',
        payroll: 'Lön',
        privacy: 'Dataskyddsregister',
      },
    },
    postpone: {
      title: 'Pausa påminnelserna',
      body: 'Stoppar påminnelsemejlen till den valda dagen. Själva fristen flyttas inte — förläng begäran för att flytta den.',
      untilLabel: 'Pausa till',
      untilHint: 'Senast till svarsfristen, {date}.',
      reasonLabel: 'Skäl',
      reasonHint: 'Sparas med begäran så att pausen kan motiveras senare.',
      submit: 'Pausa påminnelser',
      errorUntil: 'Välj dagen då påminnelserna börjar igen.',
      errorRange: 'Välj en dag mellan i morgon och svarsfristen.',
      errorReason: 'Ange skälet för pausen.',
    },
    veto: {
      title: 'Öppna vetofristen?',
      body: 'Under de kommande 72 timmarna hålls raderingen tillbaka: begäran kan inte stängas som raderad. Använd tiden till att kontrollera om ett bevarandekrav eller ett avslag behövs. Fristen kan inte stängas tidigare.',
      confirm: 'Öppna vetofrist',
    },
    holds: {
      title: 'Bevarandekrav',
      intro: 'Ett bevarandekrav hindrar att data raderas — genom en begäran, gallringsreglerna eller borttagningen av arbetsytan — tills det hävs. Varje krav måste bekräftas på nytt var sjätte månad.',
      placeTenant: 'Bevarandekrav för hela arbetsytan',
      empty: 'Inget bevarandekrav är aktivt.',
      lapsedNotice: 'Krav vars bekräftelsedatum har passerat: {count}. De blockerar fortfarande radering — bekräfta eller häv dem.',
      scopeTenant: 'Hela arbetsytan',
      scopeSubject: 'En person',
      lapsed: 'Bekräftelse försenad',
      placedAt: 'Infört',
      attestationDue: 'Bekräfta senast',
      basis: 'Rättslig grund',
      attest: 'Behövs fortfarande',
      attestConfirm: {
        title: 'Behålla kravet?',
        body: 'Du bekräftar att skälet för bevarandekravet fortfarande gäller. Det gäller i ytterligare sex månader.',
        confirm: 'Behåll kravet',
      },
      release: {
        open: 'Häv',
        title: 'Häv bevarandekravet',
        warning: 'Från och med nu får de data som kravet skyddade raderas — genom öppna begäranden, gallringsreglerna eller borttagningen av arbetsytan. Det går inte att ångra.',
        reasonLabel: 'Varför behövs kravet inte längre?',
        reasonHint: 'Sparas med ditt namn.',
        submit: 'Häv kravet',
        errorReason: 'Ange skälet för hävningen.',
      },
      place: {
        titleTenant: 'Bevarandekrav för hela arbetsytan',
        titleSubject: 'Bevarandekrav för den här personen',
        bodyTenant: 'Så länge kravet gäller får inga data i den här arbetsytan raderas — varken genom begäranden, gallringsreglerna eller borttagningen av arbetsytan.',
        bodySubject: 'Så länge kravet gäller får inga data om personen som den här begäran gäller raderas. Begäran måste ändå besvaras i tid.',
        reasonLabel: 'Skäl',
        reasonHint: 'Till exempel rättsprocessen eller myndighetens begäran som kräver att data bevaras.',
        basisLabel: 'Rättslig grund (valfritt)',
        basisHint: 'En kort hänvisning, till exempel lagrummet eller diarienumret.',
        submit: 'Inför krav',
        errorReason: 'Ange skälet för bevarandekravet.',
      },
      errors: {
        notActive: 'Det här kravet är inte längre aktivt — det har ändrats under tiden. Listan har lästs in på nytt.',
      },
    },
    restrictions: {
      title: 'Begränsningar av behandlingen',
      intro: 'En begränsad post får sparas men inte användas (art. 18 GDPR). Innan en begränsning hävs måste personen underrättas.',
      empty: 'Ingen behandling är begränsad.',
      originSystem: 'Införd efter en radering',
      originRequest: 'Från en begäran',
      notified: 'Personen underrättad {date}',
      notNotified: 'Personen inte underrättad än',
      placedAt: 'Begränsad sedan {date}',
      notifyOpen: 'Underrätta personen',
      notifyAgain: 'Registrera ny underrättelse',
      lift: 'Häv begränsningen',
      liftConfirm: {
        title: 'Häva begränsningen?',
        body: 'Posten kan användas igen som tidigare. Personen har underrättats.',
        bodySystem: 'Den här begränsningen infördes automatiskt på det som sparades efter att personens data raderades. Om den hävs går posterna att redigera och använda igen. Häv den bara om begränsningen inte längre behövs.',
        confirm: 'Häv begränsningen',
      },
      errors: {
        notActive: 'Den här begränsningen är inte längre aktiv, eller så har personen inte underrättats än. Listan har lästs in på nytt.',
      },
      place: {
        title: 'Begränsa behandlingen',
        body: 'Posten för personen som den här begäran gäller sparas men får inte längre användas förrän begränsningen hävs. Begränsningen kopplas till den här begäran.',
        reasonLabel: 'Skäl',
        reasonHint: 'Till exempel: personen bestrider att uppgifterna är korrekta.',
        submit: 'Begränsa',
        errorReason: 'Ange skälet för begränsningen.',
      },
      notify: {
        title: 'Underrätta personen',
        body: 'Personen måste underrättas innan begränsningen hävs (art. 18.3 GDPR).',
        modeLabel: 'Hur underrättas personen?',
        modeSend: 'lumi skickar ett mejl',
        modeManual: 'Redan underrättad på annat sätt',
        manualOnly: 'Den här begränsningen är inte kopplad till någon begäran, så lumi har ingen adress. Underrätta personen själv och registrera det här.',
        employerLabel: 'Arbetsgivare som nämns i mejlet',
        employerHint: 'Personen måste kunna se vem som begränsade hens uppgifter.',
        refLabel: 'Referens',
        refHint: 'Hur du underrättade personen, till exempel ”brev den 3 maj” eller ett diarienummer.',
        dateLabel: 'Underrättad den',
        dateHint: 'Lämna tomt för i dag.',
        submitSend: 'Skicka mejl',
        submitManual: 'Registrera underrättelse',
        sendRefused: 'Mejlet kunde inte skickas: begäran innehåller ingen e-postadress. Underrätta personen på annat sätt och registrera det.',
        errorEmployer: 'Ange arbetsgivaren.',
        errorRef: 'Ange en referens för underrättelsen.',
      },
    },
    review: {
      title: 'Granska kopian',
      intro: 'Så kommer personen att läsa sin kopia. Du avgör varje markerad post för sig: frisläpp eller håll tillbaka (art. 15.4 GDPR). Allt annat är skrivskyddat.',
      back: 'Tillbaka till begärandena',
      counter: {
        undecided: '{undecided} av {flagged} poster återstår att avgöra',
        allDecided: 'Alla {flagged} markerade poster är avgjorda',
        noneFlagged: 'Ingen post är markerad – du kan frisläppa kopian direkt',
      },
      modules: {
        people: 'Personal',
        ats: 'Ansökningar',
        time: 'Tid',
        apprentice: 'Lärlingsutbildning',
      },
      moduleState: {
        notInstalled: 'Den här modulen ingår inte i arbetsytan, så inget är lagrat där.',
        removed: 'Den här modulen har tagits bort från arbetsytan; inget om personen finns kvar i den.',
        unavailable: 'Den här modulen gick inte att nå när kopian sammanställdes – det här området saknas i kopian. Sätt begäran på ”Vänta på personen” och sedan på ”Börja arbeta med den” igen, så sammanställer lumi kopian på nytt – eller frisläpp den medvetet utan det här området.',
      },
      moduleEmpty: 'Inget om personen är lagrat här.',
      delivered: 'Levererad – lumi avslutar begäran strax',
      self: {
        title: 'Den här begäran gäller dig själv',
        description: 'En annan dataskyddsansvarig måste granska kopian. Du kan besvara begäran manuellt i stället.',
      },
      unverified: 'lumi kunde just nu inte kontrollera om den här begäran gäller dig själv. Försök igen om en stund.',
      sectionMeta: 'Behandling: {activity}',
      flagged: 'Markerad',
      flagReason: {
        written: 'Skriven av någon annan om personen, eller nämner andra personer. Väg om personen får läsa den här posten.',
        generic: 'Kan innehålla uppgifter om andra personer eller komma från andra. Väg den enligt art. 15.4 GDPR.',
      },
      state: {
        undecided: 'Inte avgjord än',
        release: 'Frisläpps',
        withhold: 'Hålls tillbaka',
      },
      decision: {
        group: 'Beslut om en post i ”{section}”',
        release: 'Frisläpp',
        withhold: 'Håll tillbaka',
        changeReason: 'Ändra skälet',
        reasonLabel: 'Skäl till personen',
        reasonHint: 'Personen läser det här skälet i sin kopia. Skriv det för henne och återge inte postens innehåll.',
        reasonSave: 'Spara som tillbakahållen',
        reasonRequired: 'Ange ett skäl.',
        saveError: 'Beslutet kunde inte sparas. Posten behåller sitt tidigare läge.',
      },
      release: {
        action: 'Frisläpp kopian',
        blocked: 'Avgör först de {undecided} öppna markerade posterna, sedan kan du frisläppa kopian.',
        confirmTitle: 'Frisläppa kopian?',
        confirmBody: 'lumi skapar nu kopian utan de tillbakahållna posterna ({withheld}), underrättar personen och avslutar begäran.',
        confirmBodyNone: 'lumi skapar nu kopian, underrättar personen och avslutar begäran.',
        confirmLabel: 'Frisläpp',
        done: 'Frisläppt – lumi levererar kopian',
      },
      errors: {
        undecided: 'Det finns fortfarande öppna markerade poster. Sidan har lästs in på nytt.',
        expired: 'Kopian har gått ut – lumi skapar en ny, och du ser den här igen inom kort',
        closed: 'Begäran är inte längre öppen. Kopian kan inte längre frisläppas.',
      },
      notFound: {
        title: 'Ingen kopia väntar här',
        description: 'Kopian har gått ut eller har redan levererats. Om begäran fortfarande är öppen skapar lumi en ny, och du ser den snart i listan igen.',
      },
    },
  },
  legalNotices: {
    title: 'Integritets- och AI-information för anställda',
    intro: 'Vad denna arbetsyta berättar för sina egna anställda om integritet och användning av AI på jobbet.',
    titleLabel: 'Titel',
    contentLabel: 'Informationstext',
    editMode: 'Redigera',
    previewMode: 'Förhandsgranska',
    state: {
      lumi: 'Här står lumis aktuella text.',
      own: 'Här står din egen text.',
      revisionCandidate: 'lumi har reviderat den här texten. Tills du antar den läser sökande fortfarande den tidigare texten.',
      revisionEmployee: 'lumi har reviderat den här texten. Tills du antar den läser anställda fortfarande den tidigare texten.',
      shownLumi: 'Det är lumis tidigare text.',
      shownOwn: 'Det är din egen text.',
      unavailable: 'lumis aktuella text kan inte läsas just nu.',
    },
    editText: 'Anpassa texten',
    diffOwn: 'Skillnader mot lumis text',
    diffRevision: 'Visa skillnader',
    diffHide: 'Dölj skillnader',
    returnToLumi: 'Återgå till lumis text',
    takeRevision: 'Anta',
    returnConfirm: { title: 'Återgå till lumis text?', body: 'Din text ersätts på båda språken av lumis aktuella text, med uppgifterna för din workspace redan ifyllda.' },
    takeConfirm: { title: 'Anta lumis reviderade text?', body: 'lumis aktuella text ersätter texten på båda språken. Dina uppgifter – företagsnamn, adress med mera – förblir ifyllda.' },
    diff: {
      label: 'Skillnader i texten',
      legend: 'Grönt tillkommer med lumis aktuella text, överstruket rött faller bort.',
      same: 'Ingen skillnad: texten är ordagrant densamma som lumis aktuella text.',
      unchanged: '… {count} oförändrat stycke … | … {count} oförändrade stycken …',
      inserted: 'Tillagt:',
      removed: 'Borttaget:',
    },
    adopted: 'lumis text har antagits.',
    saved: 'Sparat.',
    noticeRequired: 'Informationen kan inte sparas tom.',
    lumiVersionUnavailable: 'lumis aktuella text kunde inte nås just nu — försök igen strax.',
    forbidden: 'Du har inte åtkomst till denna information.',
    supportRefused: 'En supportsession täcker inte denna information.',
    membershipUnavailable: 'Din åtkomst kunde inte kontrolleras just nu — försök igen strax.',
    loadFailed: 'Informationen kunde inte laddas.',
    blanksOpenRefusal: 'Texten innehåller fortfarande öppna fält: {list}. Fyll i dem ovan, eller ersätt dem med egen text, innan du sparar.',
    unsavedWarning: 'Du har inte sparat dina ändringar i {name} än.',
    demoDisclaimer: 'DETTA ÄR DEMOVERSIONEN FÖR ETT FIKTIVT DEMOFÖRETAG. INTE ETT RÄTTSLIGT BINDANDE DOKUMENT.',
    blanks: {
      lead: 'lumis mallar behöver dessa uppgifter från dig. Fyll i varje uppgift en gång – den skrivs in i alla texter nedan, på båda språken.',
      saved: 'Sparat.',
      complete: 'All nödvändig information har angetts.',
      suggested: 'Hämtad från din företagsprofil – kontrollera den och spara sedan.',
      retentionOptions: { m3: '3 månader', m6: '6 månader', m12: '12 månader' },
      retentionLineMissing: 'Din egen text ({locales}) anger inte längre lagringstiden efter ett avslag. Den måste innehålla {words} – redigera texten och sätt tillbaka meningen.',
      retentionInvalid: 'Välj 3, 6 eller 12 månader.',
      retentionAnonymises: 'Från och med det här valet anonymiserar lumi avslagna ansökningar efter den här tiden, även redan avslagna. Anonymisering kan inte ångras.',
      quoted: '”{text}”',
      whyLabel: 'Varför',
      whereLabel: 'Var det står',
      keys: {
        company_name: {
          label: 'Företagsnamn', hint: 'Det juridiska namnet på denna workspace, så som det ska stå i hänvisningen.',
          why: 'En integritetsinformation måste säga vem som ansvarar för uppgifterna.',
          where: 'I avsnittet ”Personuppgiftsansvarig” i integritetsinformationen för sökande, i slutmeningen av informationen om AI-användning för sökande och i avsnittet ”Personuppgiftsansvarig” i informationen för anställda – läses av sökande och anställda.',
        },
        company_address: {
          label: 'Företagsadress', hint: 'Postadressen där anställda och sökande kan nå dig.',
          why: 'Den som har en fråga eller en begäran måste kunna nå det ansvariga företaget per post.',
          where: 'Direkt efter företagsnamnet, på samma tre ställen.',
        },
        privacy_contact: {
          label: 'Dataskyddskontakt', hint: 'Vem man kan fråga om dataskydd — ett namn, en roll eller en e-postadress.',
          why: 'De registrerade måste veta vem de kan vända sig till om dataskydd och om sina rättigheter.',
          where: 'I meningen ”För frågor om dataskydd kan du kontakta …” i integritetsinformationen för sökande och i informationen för anställda, samt i styckena om rättigheter i alla tre texterna – läses av sökande och anställda.',
        },
        applicant_retention: {
          label: 'Lagringstid efter ett avslag', hint: 'Samma inställning som ATS ▸ Dataskydd ▸ Automatisk anonymisering: lumi anonymiserar avslagna ansökningar efter den här tiden, så informationen kan bara lova det som produkten gör.',
          why: 'En information utan angiven tid informerar ingen. Tills en tid har valts räknas integritetsinformationen för sökande som ofullständig och karriärportalen förblir offline.',
          where: 'I meningen ”Lagring efter ett avslag: …” i integritetsinformationen för sökande – läses av sökande. Senare kan du ändra den på den här sidan eller under ATS ▸ Dataskydd.',
        },
      },
    },
    // The page's two-step checklist (issue 766): the facts form, then the imprint.
    checklist: {
      title: 'Så blir dina juridiska texter kompletta',
      progress: '{done} av {total} klart',
      facts: { title: 'Uppgifter för alla texter', hint: 'Företagsnamn, adress, dataskyddskontakt med mera – infogas i varje text nedan.' },
      imprintAction: 'Fyll i juridisk information',
    },
    candidate: {
      heading: 'Information för kandidater',
      intro: 'Den juridiska information som den här arbetsytan visar för kandidater i karriärportalen.',
      unavailable: 'Informationen för kandidater är inte tillgänglig just nu.',
      noticeRequired: 'Den här informationen visas för de sökande och får inte vara tom. Ersätt texten eller ta över lumis version.',
      imprintRequired: 'Den juridiska informationen kan inte tömmas medan portalen är live. Ersätt texten i stället för att radera den.',
      retentionLineRequired: 'Informationen måste ange lagringstiden efter ett avslag. Den hämtas från raderingsinställningen – behåll ”{words}” i texten.',
      privacy: {
        title: 'Klientspecifik integritetspolicy',
        subtitle: 'Denna version visas på portalen för sökande.',
      },
      aiUsage: {
        title: 'Information om AI-användning för sökande',
        subtitle: 'Den här texten visas för sökande på karriärportalen.',
      },
      imprint: {
        title: 'Karriärportalens juridiska information',
        subtitle: 'Texten länkas från varje sida i portalen.',
        hint: 'Juridisk information krävs enligt lag (§ 5 DDG). Din karriärportal är offline tills den har sparats på något språk.',
        fallsBack: 'Din juridiska information är sparad. Språk utan egen juridisk information visar {language}-versionen i portalen.',
      },
      history: {
        title: 'Vad visade vi ett visst datum?',
        hint: 'Slå upp den exakta texten som fanns på den här sidan vid en tidpunkt i det förflutna — för en kandidats eller en tillsynsmyndighets fråga.',
        open: 'Slå upp',
        hide: 'Stäng',
        dateLabel: 'Datum och tid',
        localeLabel: 'Språk',
        lookUp: 'Visa texten',
        periodClosed: 'Publicerad från {from} till {until}.',
        periodOpen: 'Publicerad sedan {from} – fortfarande den aktuella texten.',
        sourceLumi: 'lumis publicerade version {version}, ord för ord.',
        sourceLumiUnversioned: 'lumis publicerade text.',
        sourceTenant: 'Den här arbetsytans egen text, avgrenad från lumi-version {version}.',
        sourceTenantOwn: 'Den här arbetsytans egen text.',
        none: 'Registret sträcker sig inte så långt tillbaka.',
        provenanceFollowing: 'Det som är känt: den här sidan är en kopia av lumi-version {version} och har aldrig skrivits över här.',
        provenanceBranched: 'Det som är känt: den här sidan kommer från lumi-version {version} och skrevs över den {date}.',
        provenanceUnknown: 'Inget mer finns registrerat om den här sidan för tiden dessförinnan.',
        futureRefused: 'Registret säger vad en sida har visat, inte vad den kommer att visa. Välj en tidpunkt som redan passerat.',
        invalidRefused: 'Välj ett datum och ett språk för uppslagningen.',
        failed: 'Registret kunde inte läsas just nu. Försök igen.',
      },
    },
  },
  legalNoticePublic: {
    unavailable: 'Denna information är inte tillgänglig just nu.',
  },
  dataImportHub: {
    segments: {
      import: 'Import',
      export: 'Export',
      label: 'Import eller export',
    },
    umzug: {
      label: 'Din flytt',
      from: 'Flytt från',
      pick: 'Välj flytt',
      files: '{count} fil, senast {when} | {count} filer, senast {when}',
      startNew: 'Ny flytt',
      nameIntro: 'En flytt samlar filerna från samma system. Ge den ett namn, helst det gamla systemets.',
      nameLabel: 'Det gamla systemets namn',
      nameHint: 'Små bokstäver, siffror, bindestreck och understreck; inget annat sparas.',
      namePlaceholder: 't.ex. personio',
      begin: 'Starta flytten',
      nameReserved: 'Lumi kan inte använda det här namnet. Välj ett annat.',
      together: 'Filerna i en flytt hör ihop: senare filer hittar det tidigare skapade. Först grunderna, sedan det som bygger på dem.',
    },
    order: 'Flyttens ordning',
    entries: {
      orgUnits: {
        title: 'Avdelningar & platser',
        description: 'Avdelningar, team, platser och kostnadsställen från det gamla systemet.',
        reason: 'Avdelningar och platser är grunden för allt annat.',
      },
      persons: {
        title: 'Medarbetare',
        description: 'Alla som arbetar hos dig, med grunduppgifter, avdelning och chef.',
        reason: 'Du behöver medarbetarna för avtal, tider och frånvaro.',
      },
      contracts: {
        title: 'Avtal',
        description: 'Medarbetarnas anställningsavtal.',
        needs: 'behöver medarbetarna',
        reason: 'Avtalen hör till medarbetarna.',
      },
      ats: {
        title: 'Tjänster, kandidater & ansökningar',
        description: 'Öppna och tidigare tjänster med sina kandidater och ansökningar.',
        needs: 'behöver avdelningar & platser',
        reason: 'Tjänsterna hänvisar till dina platser.',
      },
      time: {
        title: 'Kunder, projekt, tider & frånvaro',
        description: 'Kunder, projekt, registrerade tider och frånvaro.',
        needs: 'behöver medarbetarna',
        reason: 'Tider och frånvaro hör till medarbetarna.',
      },
    },
    state: {
      next: 'Näst på tur.',
      imported: '{count} importerade · {file} · {when}',
      importedMany: '{count} importerade · {files} filer · senast {when}',
      unfinished: 'Påbörjad med {file}',
    },
    actions: {
      resume: 'Fortsätt',
      supplement: 'Komplettera',
      continueHere: 'Fortsätt med den här',
    },
    drop: {
      title: 'Dra en fil hit eller välj en',
      hint: 'CSV eller Excel; en export från det gamla systemet räcker.',
      after: 'Därefter:',
      savedLast: 'ingenting sparas förrän i sista steget',
    },
    ai: {
      label: 'Lumi förbättrar kopplingen',
      infoLabel: 'Vad som går till Lumi',
      infoSent: 'Bara kolumnnamnen och högst 20 exempelvärden per kolumn går till AI:n. Från kolumner vars namn tyder på känsliga uppgifter skickas inga värden.',
      infoProposal: 'Resultatet är bara ett förslag: du granskar och bekräftar varje koppling själv.',
      infoQuota: 'Förbättringen räknas mot din AI-kvot.',
      quotaUsedUp: 'Ingen AI-kvot kvar till {date}.',
      quotaUsedUpNoDate: 'Ingen AI-kvot kvar under den här perioden.',
      suspended: 'Lumi är avstängt i den här arbetsytan.',
      raise: 'Höj kvoten',
      withoutQuota: 'Enligt regler',
    },
    lock: {
      body: 'I {module} saknar du behörigheten {permission}. Den hör till rollen {role}; enbart suite-admin räcker inte. Den ges i Personal under {where} av någon med rollen {granters}.',
      permissionImport: 'Importera data',
      permissionExport: 'Exportera data',
      accessPage: 'Rättigheter & tilldelningar',
      adminRole: '{module}-admin',
      granters: 'ägare eller suite-administratör',
      askSomeone: 'Be någon med rollen {role} om det.',
      grantSelf: 'Ge mig det själv (Personal → Rättigheter & tilldelningar)',
      mayManage: 'Du får hantera åtkomst.',
    },
    lists: {
      imports: 'Importer i den här flytten ({count})',
      others: 'Andra flyttar ({count})',
      show: 'Visa',
      hide: 'Dölj',
      noImports: 'Inget har importerats i den här flytten ännu.',
      noOthers: 'Inga andra flyttar.',
      retention: 'Filer och rapporter raderas 30 dagar efter importen; de överförda uppgifterna finns kvar.',
      report: 'Rapport',
      delete: 'Radera',
      switchTo: 'Byt',
      you: 'du',
      columns: {
        file: 'Fil',
        entry: 'Del',
        result: 'Resultat',
        when: 'När',
        by: 'Av',
      },
    },
    result: {
      done: 'Överfört',
      review: 'Ska granskas',
      questions: 'Frågor öppna',
      reading: 'Läses',
      checking: 'Kontrolleras',
      committing: 'Överförs',
      cancelled: 'Avbruten',
      failed: 'Misslyckades',
      created: '{count} nya',
      updated: '{count} uppdaterade',
      unchanged: 'inget ändrat',
      toClarify: '{count} att reda ut',
    },
    done: {
      headline: 'Framme i {module}: {count} {things}.',
      headlineRecords: 'Framme i {module}: {count} poster.',
      numbers: '{created} skapade · {updated} uppdaterade',
      notImported: '{count} rad inte överförd | {count} rader inte överförda',
      leftOut: '{count} rad som du lämnade utanför | {count} rader som du lämnade utanför',
      downloadList: 'Ladda ner listan',
      laterHint: ' (den finns inte kvar senare)',
      skipped: '{count} rad hoppades över oförändrad | {count} rader hoppades över oförändrade',
      soFar: 'Så långt har du kommit',
      rowsIn: '{count} importerade',
      asNext: 'Näst på tur: {reason}',
      whatNext: 'Hur går det vidare?',
      nextTitle: 'Vidare med: {entry}',
      nextAction: 'Nästa fil',
      orgChartTitle: 'Se organisationsschemat',
      orgChartBody: 'Kontrollera att avdelningar och chefer kom fram som du känner dem.',
      orgChartBuildTitle: 'Bygg organisationsschemat',
      orgChartBuildBody: 'Alla är sin egen chef tills vidare. Vem som rapporterar till vem bygger du nu upp i Personal.',
      accessTitle: 'Ge åtkomst',
      accessBody: 'Medarbetarna finns där, men ingen kan logga in ännu. Åtkomst ger du i Personal.',
      openPeople: 'Öppna i Personal',
    },
    export: {
      title: 'Export',
      intro: 'Hämta ut dina data ur en modul. Varje export körs under din behörighet i den modulen.',
      covers: {
        people: 'Medarbetare, avdelningar, avtal',
        ats: 'Tjänster, kandidater, ansökningar',
        time: 'Kunder, projekt, tider, frånvaro',
      },
      locked: 'I {module} saknar du behörigheten {permission}. Den hör till rollen {role}.',
      last: 'Senast exporterad {when} · {count} poster',
      none: 'Inte exporterad ännu.',
      past: 'Tidigare exporter',
      columns: {
        module: 'Modul',
        by: 'Av',
      },
      standard: 'Standardexport',
      expired: 'Utgången',
      archive: '{whole} hittar du under {link}.',
      archiveWhole: 'Arbetsytans hela datamängd',
    },
    run: {
      breadcrumb: 'Flytt från {umzug} › {entry} · {file}',
    },
    nav: 'Dataimport',
    title: 'Dataimport & -export',
    locked: 'Ingen behörighet i denna modul',
    plan: {
      failed: 'De extra uppgifterna kunde inte skapas.',
      companionErrors: 'Fel uppstod när de extra uppgifterna skapades. Kontrollera dem i själva modulen.',
      projectionTimeout: 'De extra uppgifterna har inte nått målmodulen ännu. Försök igen senare.',
    },
    createField: {
      title: 'Skapa nytt eget fält',
      intro: 'Skapa ett eget fält för kolumnen ”{column}”. Det blir sedan tillgängligt i hela ATS.',
      typeHint: 'Valfält (select/flerval) skapas i fälthanteringen.',
      sensitiveNotImportable: 'Fält i särskilda kategorier (art. 9) skapas men är avsiktligt inte ett importmål.',
      submit: 'Skapa fält',
      label: 'Etikett',
      keyLabel: 'Fältnyckel (Key)',
      keyHint: 'Endast små bokstäver, siffror och understreck',
      typeLabel: 'Typ',
      types: {
        text: 'Text',
        textarea: 'Textområde',
        number: 'Tal',
        date: 'Datum',
        checkbox: 'Kryssruta',
      },
      sensitivityLabel: 'Vilken typ av uppgifter innehåller fältet?',
      sensitivityUnanswered: 'Välj ett alternativ',
      sensitivityNone: 'Ingen särskild kategori',
      sensitivityHint: 'Känsliga uppgifter (art. 9 GDPR) får inte styra automatiska beslut om en ansökan.',
      sensitivityCategories: {
        racialEthnic: 'Ras eller etniskt ursprung',
        politicalOpinion: 'Politiska åsikter',
        religiousPhilosophical: 'Religiös eller filosofisk övertygelse',
        tradeUnion: 'Medlemskap i fackförening',
        genetic: 'Genetiska uppgifter',
        biometricId: 'Biometrisk identifiering',
        health: 'Hälsouppgifter',
        sexLifeOrientation: 'Sexualliv eller sexuell läggning',
      },
      sensitivityRequired: 'Ange vilken typ av uppgifter fältet innehåller.',
    },
    entities: {
      person: 'Medarbetare',
      orgUnit: 'Org-enheter',
      employmentContract: 'Avtal',
      job: 'Tjänster',
      candidate: 'Kandidater',
      application: 'Ansökningar',
      client: 'Kunder',
      project: 'Projekt',
      timeEntry: 'Tidsposter',
      leaveRequest: 'Frånvaro',
    },
    // People's enum values in the words People uses for them (people-ui's own
    // labels): the import wizard names allowed values with these.
    peopleValues: {
      gender: {
        male: 'Man',
        female: 'Kvinna',
        diverse: 'Annat',
        undisclosed: 'Ej angivet',
      },
      maritalStatus: {
        single: 'Ogift',
        married: 'Gift',
        divorced: 'Skild',
        widowed: 'Änka/änkling',
        registered_partnership: 'Registrerat partnerskap',
        separated: 'Separerad',
      },
      contractType: {
        permanent: 'tillsvidare',
        fixed_term: 'tidsbegränsad',
        mini_job: 'minijobb',
        midi_job: 'midijobb (övergångsintervall)',
        working_student: 'arbetande student',
        apprenticeship: 'lärlingsutbildning',
        internship: 'praktik',
        freelance: 'frilans / på arvode',
        managing_director: 'verkställande direktör / styrelseledamot',
        other: 'övrigt',
      },
      workTimeArrangement: {
        full_time: 'heltid',
        part_time: 'deltid',
        marginal: 'marginell (minijobb)',
        variable: 'variabel / flexibel',
      },
      status: {
        draft: 'Utkast',
        active: 'Aktiv',
        on_hold: 'Pausad',
        terminated: 'Avslutad',
        inactive: 'Inaktiv',
      },
      type: {
        department: 'Avdelning',
        location: 'Ort',
        team: 'Team',
        cost_center: 'Kostnadsställe',
      },
    },
    // People's import fields in People's own words (people-ui's labels), per
    // entity: the wizard's row errors name a field with these, never by its key.
    peopleFields: {
      orgUnit: {
        externalId: 'Externt ID',
        type: 'Typ',
        name: 'Namn',
        code: 'Kod',
        description: 'Beskrivning',
        parentExternalId: 'Överordnad enhet',
        parentCode: 'Överordnad enhet (Kod)',
        addressLine1: 'Adress',
        postalCode: 'Postnummer',
        city: 'Ort',
        country: 'Land',
        active: 'Aktiv',
      },
      person: {
        externalId: 'Externt ID',
        employeeNumber: 'Anställningsnummer',
        firstName: 'Förnamn',
        lastName: 'Efternamn',
        salutation: 'Tilltal',
        gender: 'Kön',
        email: 'E-post',
        phone: 'Telefon',
        birthDate: 'Födelsedatum',
        nationality: 'Nationalitet',
        maritalStatus: 'Civilstånd',
        addressLine1: 'Adress',
        addressLine2: 'Adresstillägg',
        postalCode: 'Postnummer',
        city: 'Ort',
        country: 'Land',
        workCountry: 'Arbetsort (land)',
        primaryLocale: 'Språk',
        status: 'Status',
        primaryOrgUnitExternalId: 'Avdelning / enhet',
        primaryOrgUnitCode: 'Avdelning / enhet (Kod)',
        supervisorExternalId: 'Funktionell chef',
      },
      employmentContract: {
        externalId: 'Externt ID',
        personExternalId: 'Person',
        contractReference: 'Avtalsnummer',
        status: 'Avtalsstatus',
        startDate: 'Startdatum',
        endDate: 'Slutdatum',
        probationEndDate: 'Provanställningens slut',
        contractType: 'Anställningsform',
        position: 'Befattning / uppgift',
        primaryOrgUnitExternalId: 'Avdelning / enhet',
        supervisorExternalId: 'Chef',
        workTimeArrangement: 'Arbetstid',
        weeklyHours: 'Timmar per vecka',
        vacationDaysPerYear: 'Semester (dagar/år)',
        collectiveAgreementCode: 'Kollektivavtal',
      },
    },
    // The ATS import's fields in the ATS UI's own words, per entity (the guided import,
    // issue 1063): the mapping step and the row errors name a field with these, never
    // by its key. Every key of ats-api's import-descriptor.ts has one in every locale.
    atsFields: {
      job: {
        externalId: 'Externt ID',
        title: 'Befattningsbenämning',
        departmentName: 'Avdelning',
        locationName: 'Ort',
        state: 'Status',
        headcount: 'Antal tjänster',
        employmentType: 'Anställningsform',
        requiredSkills: 'Nödvändiga färdigheter',
      },
      candidate: {
        externalId: 'Externt ID',
        firstName: 'Förnamn',
        lastName: 'Efternamn',
        email: 'E-post',
        phone: 'Telefon',
        skills: 'Färdigheter',
        availableFrom: 'Tillgänglig från',
        noticePeriodDays: 'Uppsägningstid (dagar)',
        remotePreference: 'Önskad arbetsplats',
        salaryExpectation: 'Löneanspråk (per år)',
        seniority: 'Erfarenhetsnivå',
        poolTags: 'Talangpoolstaggar',
      },
      application: {
        externalId: 'Externt ID',
        candidateExternalId: 'Kandidat',
        jobExternalId: 'Tjänst',
        state: 'Steg',
        appliedAt: 'Ansökt den',
        note: 'Anteckning',
      },
    },
    // The ATS descriptor's fixed enum values in the ATS UI's words (the workflow states and
    // the department/location names are the workspace's own and need none).
    atsValues: {
      remotePreference: {
        onsite: 'På plats',
        hybrid: 'Hybrid',
        remote: 'Distans',
      },
      seniority: {
        junior: 'Junior',
        mid: 'Mellannivå',
        senior: 'Senior',
        lead: 'Lead',
      },
    },
    // Time's import fields in Time's own words, per entity (see atsFields).
    timeFields: {
      client: {
        externalId: 'Externt ID',
        name: 'Namn',
        isInternal: 'Intern',
      },
      project: {
        externalId: 'Externt ID',
        name: 'Projektnamn',
        clientExternalId: 'Kund',
        externalRef: 'Projektreferens',
        description: 'Beskrivning',
        status: 'Status',
        isBillable: 'Fakturerbar',
        hourlyRate: 'Timtaxa',
        budgetHours: 'Timbudget',
      },
      timeEntry: {
        externalId: 'Externt ID',
        userEmail: 'Personens e-post',
        personnelNumber: 'Anställningsnummer',
        date: 'Datum',
        startTime: 'Starttid',
        endTime: 'Sluttid',
        durationMinutes: 'Varaktighet (minuter)',
        bookingType: 'Bokningstyp',
        projectExternalId: 'Projekt',
        activity: 'Aktivitet',
        note: 'Anteckning',
        status: 'Status',
      },
      leaveRequest: {
        externalId: 'Externt ID',
        userEmail: 'Personens e-post',
        personnelNumber: 'Anställningsnummer',
        leaveType: 'Typ av frånvaro',
        startDate: 'Från',
        endDate: 'Till',
        status: 'Status',
        note: 'Anteckning',
      },
    },
    // Time's enum values. `status` is shared by projects, time entries and absences, so it
    // carries the union of their values (the value maps are keyed by field, per module).
    timeValues: {
      status: {
        active: 'Aktiv',
        closed: 'Stängd',
        paused: 'Pausad',
        completed: 'Avslutad',
        archived: 'Arkiverad',
        draft: 'Utkast',
        submitted: 'Inskickad',
        approved: 'Godkänd',
        pending: 'Väntande',
        rejected: 'Avslagen',
      },
      leaveType: {
        vacation: 'Semester',
        special: 'Särskild ledighet',
        parental: 'Föräldraledighet',
        unpaid: 'Obetald ledighet',
        training: 'Utbildning',
      },
    },
  },
  // ── Tenant administration (#432): the five pages that used to be their own
  //     app. Merged verbatim from its catalogue, so the strings are unchanged.
  audit: {
    title: 'Audit Log', subtitle: 'Who did what in your workspace.',
    noAccess: 'No access', noAccessHint: 'You need the audit log permission to view this page.',
    empty: 'No audit events yet', emptyHint: 'Actions in your workspace will appear here.',
    loading: 'Loading…', loadMore: 'Load more',
    filters: { from: 'From', to: 'To', action: 'Action', category: 'Category', actor: 'Actor', outcome: 'Outcome', search: 'Search', searchHint: 'Subject or actor…', apply: 'Apply', reset: 'Reset', all: 'All', actorType: 'Aktörstyp' },
    columns: { time: 'Time', actor: 'Actor', action: 'Action', subject: 'Subject', outcome: 'Outcome' },
    outcome: { success: 'Success', denied: 'Denied', failure: 'Failure' },
    actorType: { user: 'User', system_admin: 'System Admin', support: 'Support', service: 'Service', system: 'System' },
    categories: { auth: 'Auth', access: 'Access', data: 'Data', admin: 'Admin', lifecycle: 'Lifecycle', export: 'Export', security: 'Security' },
    export: { csv: 'Export CSV', ndjson: 'Export NDJSON' },
    detail: { roles: 'Roller', action: 'Action', actorId: 'Actor ID', onBehalfOf: 'On behalf of', ip: 'IP address', source: 'Source', correlationId: 'Correlation ID', changes: 'Changes', before: 'Before', after: 'After', details: 'Details' },
    actions: { login: { succeeded: 'Login succeeded', failed: 'Login failed', attempts_flagged: 'Upprepade misslyckade inloggningsförsök', locked: 'Konto låst' }, sso: { login_succeeded: 'SSO login succeeded', connection_changed: 'SSO connection changed' }, password: { reset_requested: 'Password reset requested', reset_completed: 'Password reset completed' }, refresh_token: { revoked: 'Session revoked' }, user: { signed_up: 'User signed up', unlocked: 'Konto upplåst', disabled: 'Konto inaktiverat', enabled: 'Konto aktiverat', closed: 'Konto avslutat' }, passkey: { revoked: 'Nycklar borttagna av en administratör' }, role: { changed: 'Role changed' }, module_access: { changed: 'Module access changed' }, access: { ownership_transferred: 'Ägarskap överfört', member_removed: 'Medlem borttagen', suite_roles_changed: 'Suite-roller ändrade' }, tenant: { created: 'Tenant skapad', lifecycle: 'Tenant lifecycle change', exported: 'Tenant exporterad' }, module: { activated: 'Module activated', deactivated: 'Module deactivated' }, plan: { changed: 'Plan changed' }, tenant_ai_settings: { changed: 'AI-inställningar ändrade' }, tenant_role_editing: { changed: 'Rollredigering ändrad' }, settings: { changed: 'Settings changed' }, test_data: { seeded: 'Test data seeded', reset: 'Test data reset' }, onboarding: { setup_chosen: 'Konfiguration vald', demo_started: 'Demoläge startat', demo_seeded: 'Demodata skapad', demo_seed_failed: 'Demodata kunde inte skapas', demo_wipe_started: 'Radering av demodata startad', demo_wiped: 'Demodata raderad', demo_wipe_failed: 'Demodata kunde inte raderas', setup_finished: 'Konfiguration slutförd', demo_denied: 'Demoläge nekat', module_topup: 'Demodata tillagd för ny modul', demo_reset_started: 'Återställning av demo startad', demo_tier_switch_started: 'Byte till fullständig demo startat', demo_rebuilt: 'Demo ombyggd' }, company_profile: { created: 'Företagsprofil skapad', updated: 'Företagsprofil uppdaterad' }, org_scenario: { activated: 'Organisationsscenario aktiverat' }, people_data: { wiped: 'Personaldata raderad' }, ats_data: { wiped: 'Rekryteringsdata raderad' }, time_data: { wiped: 'Tidrapporteringsdata raderad' }, apprentice_data: { wiped: 'Utbildningsdata raderad' }, audit_log: { exported: 'Audit log exported' }, billing_charge: { paid: 'Betalning debiterad', failed: 'Betalning misslyckades', refunded: 'Betalning återbetald', chargeback: 'Återkrav mottaget' }, invoice: { issued: 'Faktura utfärdad' }, mandate: { created: 'Kort tillagt', replaced: 'Kort ersatt' }, promo_code: { redeemed: 'Kampanjkod inlöst' }, billing_account: { converted: 'Testperiod omvandlad till betald', delinquent: 'Konto förfallet', purged: 'Faktureringsdata rensad' }, dunning_case: { opened: 'Betalningspåminnelse startad' }, enforcement: { opened: 'Åtgärd inledd', advanced: 'Åtgärd eskalerad', cleared: 'Åtgärd upphävd' }, billing_exempt: { changed: 'Faktureringsundantag ändrat' }, billing_data: { wiped: 'Faktureringsdata raderad', generated: 'Testfaktureringsdata genererad' }, checkout: { completed: 'Köp slutfört', denied: 'Köp nekat' }, job: { created: 'Tjänst skapad', updated: 'Tjänst uppdaterad', submitted: 'Tjänst inskickad', archived: 'Tjänst arkiverad', deleted: 'Tjänst borttagen' }, application: { created: 'Ansökan mottagen', updated: 'Ansökan uppdaterad', transitioned: 'Ansökans status ändrad', withdrawn: 'Ansökan återkallad', transferred: 'Ansökan flyttad till en annan tjänst', transfer_declined: 'Flytt av ansökan nekad', rejected: 'Ansökan avslagen', deleted: 'Ansökan borttagen', emailed: 'Ansökningsmejl skickat' }, interview: { proposed: 'Intervju föreslagen', confirmed: 'Intervju bekräftad', cancelled: 'Intervju inställd' }, candidate: { anonymized: 'Kandidat anonymiserad', emailed: 'Mejl till kandidat skickat', identity_changed: 'Kandidatens uppgifter ändrade', identity_split: 'Kandidat utskild till egen post', identity_merged: 'Ansökan flyttad till kandidaten med denna adress' }, candidate_dossier: { accessed: 'Kandidaten visade sina egna uppgifter' }, workflow: { deleted: 'Arbetsflöde borttaget', definition: { published: 'Arbetsflöde publicerat' } }, task: { blocking_overridden: 'Blockerande uppgift åsidosatt', auto_cancelled: 'Uppgift automatiskt avbruten' }, support_access: { requested: 'Supportåtkomst begärd', approved: 'Supportåtkomst godkänd', denied: 'Supportåtkomst nekad', revoked: 'Supportåtkomst avslutad', expired: 'Supportåtkomst utgången', request_expired: 'Begäran om supportåtkomst utgången' }, ai_action: { executed: 'AI-åtgärd utförd' }, assistant_run: { proposed: 'lumi föreslog en åtgärd', approved: 'lumi-åtgärd godkänd', refused: 'lumi-åtgärd nekad', failed: 'lumi-åtgärd misslyckades' }, assistant_turn: { fanned_out: 'lumi-förfrågan omfattade flera moduler' }, payroll_export_run: { created: 'Löneexport startad', completed: 'Löneexport slutförd', failed: 'Löneexport misslyckades', downloaded: 'Löneexport nedladdad' }, payroll_period: { closed: 'Lönemånad stängd', reopened: 'Lönemånad återöppnad' }, payroll_connection: { updated: 'Lönekoppling ändrad' }, payroll_master_data: { exported: 'Lönegrunddata exporterade' }, wage_type: { created: 'Löneart skapad', updated: 'Löneart uppdaterad', deleted: 'Löneart borttagen', starter_catalog_applied: 'Standardlönearter tillagda' }, wage_assignment: { created: 'Lönekomponent tillagd', updated: 'Lönekomponent ändrad', deleted: 'Lönekomponent borttagen' }, one_time_payment: { created: 'Engångsbetalning tillagd', updated: 'Engångsbetalning ändrad', deleted: 'Engångsbetalning borttagen' }, payslip: { filed: 'Lönespecifikationer arkiverade' } },
  },
  sso: {
    title: 'Single Sign-On',
    subtitle: 'Anslut din identitetsleverantör (OIDC) så att ditt team loggar in via den.',
    issuerUrl: 'Utfärdar-URL (OIDC-discovery)',
    clientId: 'Client ID',
    clientSecret: 'Client secret',
    clientSecretKeep: 'Lämna tomt för att behålla den sparade hemligheten',
    label: 'Visningsnamn',
    allowedDomains: 'Tillåtna e-postdomäner (kommaseparerade)',
    jitEnabled: 'Skapa användare automatiskt vid första inloggningen (JIT)',
    jitDefaults: 'Standardåtkomst till moduler för nya användare',
    jitModulePlaceholder: 'Välj en modul',
    jitRoles: 'Roller',
    jitCatalogUnreadable: 'Rollerna för den här modulen kunde inte läsas. De sparade rollerna är oförändrade.',
    jitUnknownRole: '{key} (okänd)',
    addJit: 'Lägg till modul',
    remove: 'Remove',
    redirectUri: 'Redirect-URI (registrera denna i din IdP)',
    copy: 'Kopiera',
    test: 'Testa anslutningen',
    testOk: 'Discovery lyckades.',
    testFailed: 'Testet misslyckades',
    save: 'Spara',
    saved: 'Sparat.',
    delete: 'Ta bort anslutning',
    deleteConfirm: 'Vill du verkligen ta bort den här SSO-anslutningen?',
    enforce: 'Kräv inloggning endast via SSO',
    enforceHint: 'Inloggning med lösenord är inaktiverad för alla utom systemadministratörer och arbetsytans ägare.',
    noConnection: 'Ingen SSO-anslutning har konfigurerats ännu.',
    deleted: 'Anslutningen har tagits bort.',
    enforceEnabled: 'Inloggning sker nu endast via SSO.',
    enforceDisabled: 'Inloggning med lösenord är tillgänglig igen.',
    jitNeedsVerifiedDomain: 'Användare skapas automatiskt bara för adresser på en verifierad domän.',
    domainsTitle: 'E-postdomäner',
    domainsIntro: 'En domän räknas för SSO-inloggning först när du har visat att den är er: publicera den här TXT-posten i domänens DNS och kontrollera den sedan. Konton som redan är kopplade loggar in som vanligt under tiden.',
    domainStatus: { pending: 'Inte verifierad', verified: 'Verifierad', legacy: 'Verifiera snart' },
    domainLegacyUntil: 'Verifiera senast {date}',
    domainRecordName: 'Postens namn (TXT)',
    domainRecordValue: 'Postens värde',
    domainVerify: 'Kontrollera posten',
    domainVerified: '{domain} är verifierad.',
    domainError: { record_not_found: 'Ingen TXT-post hittades under det här namnet än. DNS-ändringar kan ta en stund.', value_mismatch: 'Det finns en TXT-post, men värdet stämmer inte. Kopiera värdet exakt.', dns_error: 'DNS-uppslaget misslyckades. Försök igen om några minuter.' },
  },  users: { seatLimit: { bookMore: 'Alla {booked} bokade användarplatser är upptagna. Boka minst {required} användarplatser för att bjuda in någon till.', leaveFreelancer: 'Den här arbetsytan är i frilansläge: en person, en plats. Om du lämnar frilansläget bokar du {required} användarplatser och får plats för fler personer.', notified: 'Alla {booked} bokade användarplatser är upptagna. Arbetsytans ägare och Billing Managers kan boka fler platser.', cta: 'Boka fler platser' }, removeSuccess: '{email} har tagits bort från den här arbetsytan.', saveSuccess: 'Åtkomständringar för {email} sparade.', saveFailedFor: 'Kunde inte spara {targets} för {email}: {reason}', saveFailedOthersSaved: 'Övriga ändringar sparades.', suiteRolesTarget: 'suite-rollerna', unsaved: 'Osparat', defaultRoleHint: 'Standardroll för interna inbjudningar', refreshFailed: 'Medlemslistan kunde inte uppdateras. Ladda om sidan för att se det sparade läget.', title: 'Användare & Tilldelningar', email: 'E-post', suite: 'Suite', suiteSuiteAdmin: 'Admin', suiteSuiteAdminHint: 'Workspace-admin: hanterar medlemmar, modulåtkomst, SSO och säkerhet.', suiteBillingManager: 'Billing Manager', suiteBillingManagerHint: 'Kan hantera fakturering (fakturor, kort, plan).', suiteSupportAgent: 'Support Agent', suiteSupportAgentHint: 'Hanterar supportärenden (svara, eskalera, stänga).', suiteDataProtection: 'Dataskyddsombud', suiteDataProtectionHint: 'Granskar och godkänner registrerades begäranden och raderingar och kan läsa medlemsdata i varje aktiv modul.', suiteOwnerLocked: 'Arbetsytans ägare är alltid Admin.', saveFailed: 'Kunde inte spara tilldelning', inviteSuccess: '{email} har bjudits in', invite: { titleInternal: 'Bjud in en medlem', titleExternal: 'Bjud in externt', hintInternal: 'Får automatiskt standardrollen i Tid och Personal — du kan lägga till fler roller direkt efter inbjudan.', hintExternal: 'Inga standardroller: utan en roll kan personen inte öppna någon modul. Ställ in åtkomsten direkt efter inbjudan.', submit: 'Bjud in', sentTitle: 'Inbjudan skickad', sentLead: '{email} har bjudits in och visas som Inbjuden.', sentBodyInternal: 'Har redan standardrollen i Tid och Personal.', sentBodyExternal: 'Fortfarande utan roller — ställ in vad personen får åtkomst till.', revoke: 'Dra tillbaka inbjudan', moreRoles: 'Fler roller', setupRoles: 'Ställ in roller', done: 'Klar', revokedTitle: 'Inbjudan tillbakadragen', revokedBody: '{email} har tagits bort från arbetsytan. Inbjudningslänken är inte längre giltig.' }, removeUser: 'Ta bort', confirmRemove: 'Är du säker på att du vill ta bort {email} från denna tenant? Alla modultilldelningar kommer att raderas.', statusActive: 'Aktiv', statusInvited: 'Inbjuden', statusDisabled: 'Inaktiverad', transferOwnership: 'Överför ägarskap', transferTitle: 'Överför ägarskapet för arbetsytan', transferIntro: '{from} lämnar över den här arbetsytan till {to}. Det finns bara en ägare – när du bekräftar är {from} inte längre det.', transferConsequences: 'Det här ändras:', transferConsequenceBreakGlass: 'Nödinloggningen vid SSO-avbrott går över till {to}: om er identitetsleverantör inte är tillgänglig kan {to} fortfarande logga in med lösenord, men inte {from}.', transferConsequenceOutgoing: '{from} behåller alla roller som redan finns, inklusive Admin — bara ägarskapet flyttas. {from} kan inaktiveras eller tas bort som vilken annan medlem som helst.', transferConsequenceSuiteAdmin: '{to} får rollen Admin om den saknas. Ingen förlorar någon roll.', transferSsoWarning: '{email} loggar in via SSO och har inget lösenord. Om SSO inte är tillgängligt går den ärvda nödåtkomsten inte att använda – ett lösenord går att sätta när som helst via ”Glömt lösenord”.', transferBlockedPending: '{email} har inte accepterat sin inbjudan än. Det måste ske först.', transferBlockedDisabled: 'Kontot för {email} är inaktiverat. Aktivera det igen innan du överför ägarskapet.', transferConfirmFieldLabel: 'Bekräfta den nya ägaren', transferConfirmHint: 'Skriv {email} för att aktivera knappen.', transferSuccess: '{email} äger nu den här arbetsytan.', transferFailed: 'Ägarskapet kunde inte överföras. Försök igen.', transferErrorForbidden: 'Bara den nuvarande ägaren kan överföra ägarskapet.', transferErrorNotMember: '{email} är inte längre medlem i den här arbetsytan.', transferErrorAlreadyOwner: '{email} äger redan den här arbetsytan.', transferErrorRaced: 'Ägarskapet ändrades medan den här överföringen pågick. Ladda om listan och försök igen.', transferErrorIneligible: '{email} kan inte ta över ägarskapet just nu. Uppdatera listan för att se aktuell status.', resendInvite: 'Skicka inbjudan igen', disable: 'Inaktivera', enable: 'Aktivera', confirmDisable: 'Inaktivera {email}? Personen loggas ut omedelbart och kan inte logga in förrän du aktiverar kontot igen.', resendSuccess: 'Inbjudan skickades igen till {email}.', resendEmailFailed: 'Inbjudningsmejlet till {email} kunde inte skickas. Försök igen.', disableSuccess: '{email} har inaktiverats.', enableSuccess: '{email} har aktiverats.', inviteEmailFailed: '{email} har lagts till, men inbjudningsmejlet kunde inte skickas. Du kan skicka det igen.', searchPlaceholder: 'Sök på e-post', rolesFilterPlaceholder: 'Filtrera efter roll', clearRolesFilter: 'Återställ filter', memberCount: '{count} medlemmar', memberCountFiltered: '{shown} av {count} medlemmar', inviteInternal: 'Bjud in', inviteExternal: 'Bjud in externt', removeRoleFilter: 'Ta bort roll från filtret', columns: { account: 'Konto', status: 'Status', roles: 'Roller' },moduleNames: { ats: 'Rekrytering', time_tracking: 'Tid', people: 'Personal', apprenticeship: 'Ausbildung' }, accessDenied: 'Ingen åtkomst', moreActions: 'Fler åtgärder för {email}', noSearchResults: 'Ingen medlem matchar ”{query}”.', editSubtitle: 'Redigera roller och åtkomst', suiteConfirmGrantTitle: 'Tilldela en suite-roll?', suiteConfirmRevokeTitle: 'Ta bort en suite-roll?', suiteConfirmMixedTitle: 'Ändra suite-roller?', suiteConfirmLead: 'Det här ändras för {email}:', suiteConfirmRemoved: 'Förlorar {role}.', suiteConfirmAccept: 'Ja, spara' },
  // The consent page of an agent connection (ADR 0103 rule 10, PDR 0035).
  connectAgent: {
    title: 'Anslut en AI-agent',
    heading: 'En AI-agent vill agera för din räkning',
    intro: 'En AI-klient som kallar sig ”{client}” ber om att få arbeta i lumi som du, i arbetsytan {workspace}.',
    fields: {
      client: 'Kallar sig',
      redirectHost: 'Skickar dig tillbaka till',
      website: 'Angiven webbplats',
      workspace: 'I arbetsytan',
    },
    scopesHeading: 'Den ber om att få:',
    scope: {
      read: 'Läsa det du kan se i lumi',
      act: 'Föreslå och utföra åtgärder som du — varje åtgärd kräver din bekräftelse',
      ask: 'Ställa frågor till lumi',
    },
    meaning: {
      heading: 'Vad ”Tillåt” innebär',
      asYou: 'Den agerar som du, med exakt dina behörigheter i den här arbetsytan — aldrig mer.',
      egress: 'Allt den läser i lumi går till leverantören bakom ”{client}”, utanför lumi.',
      revocable: 'Du kan avsluta anslutningen när som helst på din kontosida.',
    },
    standing: {
      label: 'Utför åtgärder på mina egna poster utan att fråga varje gång',
      hint: 'Gäller aldrig andra personers poster eller negativa beslut — där frågas du alltid. Du kan ändra detta när som helst på din kontosida.',
    },
    rolePins: {
      title: 'Roll per modul',
      hint: 'Där du har mer än en roll väljer du den som agenten arbetar i. Den kan aldrig göra mer än den rollen tillåter.',
      default: 'Modulens standard ({rule})',
      defaultRule: {
        first_assigned: 'din först tilldelade roll',
        first_by_key: 'din första roll efter nyckel',
        all_roles: 'alla dina roller tillsammans',
      },
      modules: {
        ats: 'Rekrytering',
        time: 'Tid',
        people: 'Personal',
      },
      notHeld: 'Du har inte längre den valda rollen i den modulen. Välj igen.',
    },
    disabled: {
      title: 'Externa AI-agenter är avstängda i den här arbetsytan',
      body: 'En ägare eller administratör kan slå på dem under Administration → Externa AI-agenter. Till dess kan du bara neka den här begäran.',
    },
    actions: {
      allow: 'Tillåt',
      deny: 'Neka',
    },
    returning: 'Du skickas tillbaka till {client} …',
    invalid: {
      title: 'Den här inloggningsbegäran är inte längre giltig',
      hint: 'Starta anslutningen igen från din AI-klient.',
    },
  },
  // Administration › External AI agents (ADR 0103 rule 12, PDR 0035 rule 2).
  externalAgents: {
    title: 'Externa AI-agenter',
    cardTitle: 'Externa AI-agenter',
    noAccess: 'Ingen åtkomst',
    noAccessHint: 'Endast arbetsytans ägare och suite-administratörer kan ändra den här inställningen.',
    intro: 'När detta är påslaget kan medlemmar ansluta sin egen AI-klient — Claude Code, OpenClaw, … — och låta den agera som dem i den här arbetsytan.',
    points: {
      asMember: 'En agent arbetar med exakt de behörigheter som medlemmen som anslöt den har — aldrig mer.',
      confirmed: 'Varje åtgärd den föreslår bekräftas av medlemmen innan den utförs.',
      adverse: 'Negativa beslut om andra personer kräver alltid lumi-panelen; en agent kan aldrig bekräfta dem.',
    },
    egress: {
      title: 'Vart medlemmarnas data går',
      body: 'Allt en agent läser går till den AI-klient som medlemmen ansluter — en mottagare utanför lumis kedja av personuppgiftsbiträden, vald av din arbetsyta och medlemmen.',
      worksCouncil: 'Om medlemmar får använda sådana klienter är ditt beslut som arbetsgivare — överväg att involvera de fackliga företrädarna.',
    },
    switchLabel: 'Tillåt medlemmar att ansluta externa AI-agenter',
    saving: 'Sparar …',
    activeConnections: 'Ingen anslutning är aktiv. | 1 anslutning är aktiv. | {n} anslutningar är aktiva.',
    offHint: 'Att stänga av avslutar omedelbart varje anslutning i den här arbetsytan.',
    roleNote: 'Endast arbetsytans ägare eller en suite-administratör kan ändra detta.',
    savedOn: 'Externa AI-agenter är påslagna. Medlemmar kan nu ansluta sin AI-klient.',
    savedOff: 'Externa AI-agenter är avstängda. | Externa AI-agenter är avstängda. 1 anslutning avslutades. | Externa AI-agenter är avstängda. {n} anslutningar avslutades.',
    disableConfirm: {
      title: 'Stänga av externa AI-agenter?',
      body: 'Ingen anslutning är aktiv just nu; medlemmar kan inte längre ansluta. | Detta avslutar omedelbart 1 anslutning. | Detta avslutar omedelbart {n} anslutningar.',
      confirm: 'Stäng av',
    },
  },
  supportAccess: {
    revokeConfirm: 'Supportåtkomsten upphör omedelbart. Supportteamet förlorar åtkomsten till den här arbetsytan.',
    title: 'Supportåtkomst',
    subtitle: 'Tillfällig åtkomst till din arbetsyta för vårt supportteam, som du godkänner.',
    noAccess: 'Ingen åtkomst',
    noAccessHint: 'Endast arbetsytans ägare och suite-administratörer kan granska dessa begäranden.',
    empty: 'Ingen supportåtkomst begärd',
    emptyHint: 'När vår support behöver åtkomst till din arbetsyta för ett ärende visas begäran här.',
    pendingTitle: 'Åtkomstbegäran väntar',
    pendingIntro: '{supporter} begär {days} dagars åtkomst till den här arbetsytan.',
    activeTitle: 'Supportåtkomsten är aktiv',
    activeIntro: '{supporter} kan just nu arbeta i den här arbetsytan.',
    historyTitle: 'Historik',
    revokeHint: 'Att avsluta får effekt inom en minut.',
    expiringNow: 'Går ut nu',
    remainingDays: '{days} d {hours} tim kvar',
    remainingHours: '{hours} tim {minutes} min kvar',
    remainingMinutes: '{minutes} min kvar',
    fields: {
      requestedAt: 'Begärd',
      ticket: 'Supportärende',
      duration: 'Varaktighet',
      durationValue: '{days} dagar',
      reason: 'Angiven orsak',
      approvedBy: 'Godkänd av',
      expiresAt: 'Går ut',
      remaining: 'Återstående tid',
      grantedModules: 'Tilldelade roller',
    },
    consent: { allRoles: 'Supportpersonen kan växla till varje roll som dessa moduler erbjuder — hen ser det dina medarbetare ser, inte bara adminvyn.', modulesHeading: 'Den här åtkomsten omfattar:', via: 'via {module}',
      heading: 'Detta godkänner du',
      data: 'Supporten kan nå den här arbetsytans data i alla aktiva moduler, inklusive personuppgifter om medarbetare och kandidater.',
      audited: 'Varje åtgärd registreras i din granskningslogg och märks som en supportåtgärd.',
      duration: 'Åtkomsten upphör automatiskt efter {days} dagar.',
      revocable: 'Du kan avsluta den när som helst; det får effekt inom en minut.',
    },
    actions: { approve: 'Godkänn åtkomst', deny: 'Neka', revoke: 'Avsluta nu' },
    status: {
      requested: 'Väntar',
      active: 'Aktiv',
      denied: 'Nekad',
      revoked: 'Avslutad',
      expired: 'Utgången',
      request_expired: 'Begäran utgången',
    },
    columns: { supporter: 'Supportkonto', requestedAt: 'Begärd', status: 'Status', endedAt: 'Avslutad' },
    success: { approved: 'Supportåtkomst godkänd.', denied: 'Begäran nekad.', revoked: 'Supportåtkomsten har avslutats.' },
    errors: {
      consentChanged: 'Samtyckestexten har ändrats. Läs den igen innan du godkänner.',
      selfApproval: 'Det begärande kontot kan inte godkänna sin egen begäran.',
    },
  },
  // Administration › Statutory rules (ADR 0091): the statutory rule catalogue
  // and the workspace's agreements and deviations, moved here from Time's
  // settings with the page.
  statutory: {
    title: 'Lagregler och avtal',
    intro: 'Lagreglerna gäller automatiskt och hålls aktuella centralt. Här anger du bara var ditt företag avviker från dem – varje avvikelse behöver en grund, till exempel ett kollektivavtal eller ett lokalt avtal.',
    disclaimer: 'Riktvärden enligt lag – ingen juridisk rådgivning. Kollektivavtal kan vara strängare.',
    // "Checked, fits us" (issue 713): the one-time confirmation of the statutory defaults.
    confirmation: {
      unchecked: {
        title: 'Inte granskat än',
        // The short sentence for someone who may read the page but not confirm (a support grant): no picker, no button.
        body: 'lumi startar med lagens standardregler. Om de passar er, bekräfta det. Gäller ett kollektivavtal eller ett företagsavtal hos er, skapa en avvikelse nedan.',
        confirm: 'Granskat, passar oss',
        // The mode picker (issue 780) is shown to someone who can confirm; the tile titles are the settings card's own (statutory.workspace.modeFlexible/modeStrict).
        lead: 'lumi startar med lagens standardregler – högsta arbetstid, raster, vila. Bestäm vad som händer när en registrering bryter mot en regel och bekräfta sedan att reglerna passar ert företag.',
        standard: 'Standard',
        later: 'Du kan ändra båda sakerna när som helst senare.',
        agreements: 'Gäller ett kollektivavtal eller ett företagsavtal hos er där en regel gäller annorlunda eller inte alls? Skapa då en {basis} nedan – varningarna följer den. Ett läge utan varningar finns inte.',
        agreementsBasis: 'avvikelse med sin grund',
        flexible: {
          personLabel: 'Personen', personText: 'ser vid sparandet vilken regel som överträtts och med hur mycket – registreringen finns kvar.',
          managerLabel: 'Ledningen', managerText: 'ser veckans överträdelser vid attesteringen och avgör tillsammans med personen.',
          recordLabel: 'Loggen', recordText: 'sparar varje överträdelse – för er, inte emot er.',
        },
        strict: {
          personLabel: 'Personen', personText: 'kan inte spara en registrering som bryter mot en tvingande regel – och ser varför. En saknad rast sparas och visas.',
          managerLabel: 'Ledningen', managerText: 'ser vid attesteringen bara det som ändå uppstår: saknade raster och automatiska avslut.',
          fitLabel: 'Passar om', fitText: 'undantag inte får förekomma hos er – till exempel för minderåriga.',
        },
      },
      // After a save that is not a review, while unconfirmed (issue 990): the next step, in place.
      afterSave: { body: 'Sparat. Det bekräftar ännu inte arbetstidsreglerna – bekräfta nu att de passar er.', confirm: 'Bekräfta nu' },
      confirmed: { title: 'Granskat', body: 'Bekräftat den {date} av {name}: lagens regler passar oss.', bodyNoName: 'Bekräftat den {date}: lagens regler passar oss.' },
      ownDeviation: { title: 'Granskat', body: 'Er arbetsyta har egna avvikelser, så reglerna har granskats.' },
      error: 'Bekräftelsen kunde inte sparas. Försök igen.',
    },
    noJurisdictions: 'Ingen jurisdiktion är vald ännu: det finns inga personer med arbetsort och ingen standardjurisdiktion. Välj en standard nedan så visas lagreglerna här.',
    jurisdictionEu: 'EU-direktiv',
    jurisdictionDefault: '{name} (standardval)',
    // Who the number is (issue 990): active employees in Time judged by this law —
    // on a tab that is not the default, only those whose work location is there;
    // on the default's tab, also everyone who falls back to it.
    headcountLine: 'Jurisdiktion {country}: de här reglerna gäller just nu ingen. | Jurisdiktion {country}: de här reglerna bedömer arbetstiden för 1 person i Tid som arbetar här. | Jurisdiktion {country}: de här reglerna bedömer arbetstiden för {count} personer – alla aktiva anställda i Tid som arbetar här.',
    headcountLineDefault: 'Jurisdiktion {country}: de här reglerna gäller just nu ingen. | Jurisdiktion {country}: de här reglerna bedömer arbetstiden för 1 person i Tid som arbetar här eller omfattas av standardvalet. | Jurisdiktion {country}: de här reglerna bedömer arbetstiden för {count} personer – alla aktiva anställda i Tid som arbetar här eller omfattas av standardvalet.',
    fallbackLine: 'Personer utan arbetsort, eller med en arbetsort utanför katalogen: {count} – för dem gäller {country}.',
    createModels: 'Skapa landets arbetstidsmodeller',
    domains: {
      workingTime: 'Arbetstid',
      pay: 'Tidsfönster för tillägg',
      overtime: 'Övertid',
      leave: 'Semester',
    },
    rules: {
      maxDailyHours: 'Högsta arbetstid per dag',
      maxWeeklyHours: 'Högsta arbetstid per vecka',
      breaks: 'Raster',
      minDailyRest: 'Dygnsvila',
      nightWorkBan: 'Förbud mot nattarbete',
      minWeeklyRest: 'Veckovila',
      avgWeeklyHours: 'Genomsnittlig veckoarbetstid',
      normalDailyHours: 'Ordinarie arbetstid per dag',
      normalWeeklyHours: 'Ordinarie arbetstid per vecka',
      nightWindow: 'Nattid för tillägg',
      nightCoreWindow: 'Kärnnatt för högre tillägg',
      overtimeThreshold: 'Övertid från (timmar per vecka)',
      overtimeSurcharge: 'Övertidstillägg',
      minLeaveDays: 'Minsta semester per år',
    },
    kinds: {
      collectiveAgreement: 'Kollektivavtal',
      worksAgreement: 'Lokalt avtal',
      authorityPermit: 'Myndighetsdispens',
      companyPolicy: 'Företagspolicy',
    },
    value: {
      hoursUnit: 'h',
      days: '{days} dagar',
      breakStage: '{minutes} min efter {hours} h',
      weeklyAverage: '{hours} h i genomsnitt över {weeks} veckor',
      nightWorkBan: 'inget arbete mellan {start} och {end}',
      tierFirst: '{percent} % från första övertidstimmen',
      tierAfter: '{percent} % efter {hours} övertidstimmar',
      none: 'Ingen regel',
      switchedOff: 'Regeln gäller inte (avstängd)',
    },
    status: {
      statutory: 'Enligt lag',
      noStatutoryRule: 'Ingen lagregel',
      infoOnly: 'Endast information',
      deviation: 'Avvikelse',
      deviationStricter: 'Avvikelse · strängare',
      deviationLooser: 'Avvikelse · mildare',
      deviationMoreFavourable: 'Avvikelse · förmånligare än lagen',
      deviationLessFavourable: 'Avvikelse · mindre förmånlig än lagen',
      deviationEqual: 'Avvikelse · samma som lagen',
      deviationMixed: 'Avvikelse · delvis strängare, delvis mildare',
      deviationMixedFavourable: 'Avvikelse · delvis förmånligare, delvis mindre förmånlig',
    },
    hint: {
      stricter: 'Strängare än lagen – tillåtet oavsett grund.',
      looser: 'Mildare än lagen – det kräver ett kollektivavtal, ett lokalt avtal eller en myndighetsdispens som grund.',
      moreFavourable: 'Förmånligare än lagen – tillåtet oavsett grund.',
      lessFavourable: 'Mindre förmånligt än lagen – det kräver ett kollektivavtal, ett lokalt avtal eller en myndighetsdispens som grund.',
      mixed: 'Delvis strängare, delvis mildare än lagen – det kräver ett kollektivavtal, ett lokalt avtal eller en myndighetsdispens som grund.',
      mixedFavourable: 'Delvis förmånligare, delvis mindre förmånligt än lagen – det kräver ett kollektivavtal, ett lokalt avtal eller en myndighetsdispens som grund.',
      equal: 'Samma som lagens värde – ingen avvikelse behövs.',
      incomparable: 'För den här regeln finns inget ”strängare” eller ”mildare” – vilken grund som helst går bra.',
      blocked: 'En företagspolicy får inte understiga lagen. Välj ett kollektivavtal, ett lokalt avtal eller en myndighetsdispens som grund – eller ett värde som minst motsvarar lagen.',
    },
    table: {
      rule: 'Regel',
      applies: 'Gäller',
      note: 'Kommentar till rättsläget',
      deviate: 'Avvik',
      backToStatute: 'Tillbaka till lagen',
      statutoryWouldBe: 'Enligt lag skulle gälla: {value}',
      statutoryWouldBeNone: 'Lagen har ingen regel här.',
      basis: 'Grund: {name}',
      basisWithClause: 'Grund: {name}, {clause}',
      coveredDeviation: 'Med kollektivavtalskod {code}: {value} ({name})',
      futureDeviation: 'Från {date}: {value} ({name})',
      fallbackApplies: 'Lagen anger inget tidsfönster här – det här gäller tills ett avtal anger ett annat.',
      fallbackWouldBe: 'Lagen anger inget tidsfönster här – utan avvikelsen skulle gälla: {value}',
      editDeviationOf: 'Redigera avvikelsen i ”{name}”',
      backToStatuteOf: 'Återgå till lagen för avvikelsen i ”{name}”',
    },
    notice: {
      fallback: 'Katalogen med lagregler är tillfälligt otillgänglig. Den inbyggda grundversionen visas; nyare ändringar kan saknas.',
      unjudged: 'Personer som just nu inte omfattas av någon lagregel: {count}. De saknar arbetsort och ingen standardjurisdiktion är vald – välj en nedan.',
      upcoming: 'Från {date} ändras lagregeln ”{rule}” till: {value}.',
      upcomingNone: 'Från {date} upphör lagregeln ”{rule}” att gälla.',
      upcomingDeviationStays: 'Din avvikelse gäller fortfarande.',
      reviewTitle: 'Kontrollera: {rule}',
      review: 'Lagens värde har ändrats sedan avvikelsen fastställdes ({agreement}). Enligt lag gäller nu: {statutory}. Din avvikelse: {deviation}.',
      keepDeviation: 'Behåll avvikelsen',
    },
    minors: {
      title: 'Ungdomar under 18 år',
      headcount: 'Personer: {count}',
      headcountNone: 'inga just nu',
      hint: 'För personer under 18 år gäller dessa lagstadgade skyddsregler för minderåriga i stället för de allmänna – automatiskt, utifrån födelsedatumet i Personal. Avtal avviker inte från dem.',
      generalApplies: 'Ingen egen regel ännu – tills dess gäller den allmänna.',
      upcoming: 'Från {date}: {value}',
      upcomingNone: 'Från {date} upphör denna skyddsregel för minderåriga att gälla.',
    },
    form: {
      value: 'Avvikande värde',
      daysUnit: 'dagar',
      stageAfterHours: 'Arbetstid över (h)',
      stageMinutes: 'Rast totalt (min)',
      tierAfterHours: 'Från övertidstimmar per vecka (h)',
      tierPercent: 'Tillägg (%)',
      addStep: 'Lägg till steg',
      removeStep: 'Ta bort steg {row}',
      stageAfterHoursRow: 'Steg {row}: arbetstid över (h)',
      stageMinutesRow: 'Steg {row}: rast totalt (min)',
      tierAfterHoursRow: 'Steg {row}: från övertidstimmar per vecka (h)',
      tierPercentRow: 'Steg {row}: tillägg (%)',
      averageHours: 'Timmar per vecka i genomsnitt',
      averageWeeks: 'Beräkningsperiod (veckor)',
      windowStart: 'Början',
      windowEnd: 'Slut',
      windowHint: 'Om slutet ligger före början sträcker sig fönstret över midnatt.',
      statutoryIs: 'Enligt lag gäller: {value}',
      comparisonBase: 'Utan lagregel gäller {value} – avvikelsen mäts mot det.',
      basis: 'Grund',
      basisHint: 'Avtalet som avvikelsen vilar på.',
      basisPick: 'Välj grund…',
      basisNew: 'Skapa ny grund…',
      basisRequired: 'Välj en grund.',
      clause: 'Bestämmelse',
      clauseHint: 'Var bestämmelsen står, t.ex. ”4 § andra stycket”. Valfritt.',
      invalid: {
        hours: 'Ange timmar: mer än 0 och högst 168.',
        days: 'Ange dagar: mer än 0 och högst 366.',
        breakLadder: 'Kontrollera stegen: 1 till 6 steg, stigande efter arbetstid (mer än 0 upp till 24 h), en rast på mer än 0 upp till 480 min och aldrig kortare än i steget före.',
        weeklyAverage: 'Kontrollera värdena: timmar mer än 0 och högst 168, beräkningsperiod 1 till 104 veckor.',
        timeWindow: 'Ange en start- och en sluttid; de måste skilja sig åt.',
        percentTiers: 'Kontrollera stegen: 1 till 6 steg, det första från 0 övertidstimmar, övriga stigande; tillägg mellan 0 och 300 % med högst två decimaler.',
      },
    },
    agreement: {
      name: 'Namn',
      title: 'Avtal',
      subtitle: 'Kollektivavtal, lokala avtal, dispenser och företagspolicyer – grunderna för dina avvikelser.',
      new: 'Nytt avtal',
      edit: 'Redigera avtal',
      empty: 'Inga avtal ännu – lagreglerna gäller överallt.',
      inactive: 'Gäller inte just nu',
      migrated: 'Överfört från tidigare inställningar',
      noDeviations: 'Inga avvikelser ännu. Ange dem ovan vid respektive regel.',
      needsReview: 'Kontrollera',
      kind: 'Typ av avtal',
      companyPolicyHint: 'En företagspolicy får bara vara strängare eller förmånligare än lagen.',
      nameHint: 'Till exempel ”Teknikavtalet” eller ”Lokalt avtal om raster 2026”.',
      nameRequired: 'Ge avtalet ett namn.',
      reference: 'Diarie- eller avtalsnummer',
      referenceHint: 'Valfritt, t.ex. registernummer eller beslutsnummer.',
      jurisdiction: 'Jurisdiktion',
      validFrom: 'Gäller från',
      validFromRequired: 'Ange från när avtalet gäller.',
      validTo: 'Gäller till',
      validToHint: 'Lämna tomt om avtalet gäller tills vidare.',
      validSince: 'gäller från {from}',
      validRange: 'gäller {from} – {to}',
      scope: 'Gäller för',
      scopeAll: 'alla personer i denna jurisdiktion',
      scopeCovered: 'endast personer som omfattas av kollektivavtalet',
      scopeCoveredCode: 'endast kollektivavtalskod {code}',
      coverageCode: 'Kollektivavtalskod',
      coverageCodeHint: 'Koden anges i personens anställningsavtal i Personal. Avtalet gäller bara personer med exakt den koden.',
      deleteTitle: 'Ta bort ”{name}”?',
      deleteConfirm: 'När avtalet tas bort försvinner också dess avvikelser (antal: {count}). För de reglerna gäller sedan lagen igen.',
      deleteConfirmEmpty: 'Avtalet har inga avvikelser; de gällande reglerna ändras inte.',
      editDeviation: 'Redigera avvikelse: {rule}',
      removeDeviation: 'Tillbaka till lagen: {rule}',
    },
    backConfirm: {
      title: '”{rule}”: tillbaka till lagen?',
      body: 'Avvikelsen tas bort. Därefter gäller lagens värde igen: {value}.',
      bodyNone: 'Avvikelsen tas bort. Lagen har ingen regel här – därefter gäller ingen.',
      bodyFallback: 'Avvikelsen tas bort. Lagen har ingen regel här – därefter gäller {value} igen.',
    },
    workspace: {
      title: 'Arbetsytans inställningar',
      defaultJurisdiction: 'Standardjurisdiktion',
      defaultJurisdictionHint: 'Gäller personer utan arbetsort eller med en arbetsort som katalogen inte täcker.',
      noDefault: 'Ingen standard',
      mode: 'När en registrering bryter mot en regel',
      modeFlexible: 'Varna och logga',
      modeFlexibleHint: 'Registreringen sparas. Överträdelsen visas och loggas.',
      modeStrict: 'Blockera registreringen',
      modeStrictHint: 'En registrering som bryter mot en tvingande regel kan inte sparas.',
      originSignup: 'Hämtat från landet som ditt företag angav vid registreringen: {country}.',
      originFallbackPrevious: 'Tills landet som ditt företag angav vid registreringen är känt och finns i katalogen gäller reglerna för {current} – de regler som arbetsytan hittills bedömdes efter.',
      originFallbackUnknown: 'Ditt företags land är ännu inte känt, så EU:s miniminivå gäller tills någon väljer landet här.',
      originFallbackUncovered: 'Vid registreringen angav ditt företag {country}. Katalogen har ännu inga regler för det landet, så EU:s miniminivå gäller.',
      originFallbackCovered: 'Vid registreringen angav ditt företag {country}, vars regler nu finns i katalogen. Välj det här för att tillämpa dem – till dess gäller EU:s miniminivå.',
    },
    toast: {
      settingsSaved: 'Inställningar sparade',
      deviationSaved: 'Avvikelsen sparad',
      deviationConfirmed: 'Avvikelsen bekräftad',
      backToStatute: 'Avvikelsen borttagen – lagen gäller igen',
      agreementSaved: 'Avtalet sparat',
      agreementDeleted: 'Avtalet borttaget',
      modelsCreated: 'Skapade arbetstidsmodeller: {count}',
      modelsExist: 'Landets arbetstidsmodeller finns redan.',
    },
    errors: {
      rival: '”{name}” fastställer redan den här regeln för samma personer under en överlappande period.',
      validToBeforeFrom: 'Giltighetens slut får inte ligga före dess början.',
      coverageCodeRequired: 'Ange den kollektivavtalskod som avtalet gäller för.',
      invalidValue: 'Värdet är inte giltigt för den här regeln. Kontrollera det.',
      jurisdictionUnknown: 'Den här jurisdiktionen finns inte i katalogen med lagregler.',
      dateInvalid: 'Ange ett giltigt datum.',
      labelInvalid: 'Kontrollera textfälten: namnet är obligatoriskt och inget fält får vara längre än 160 tecken.',
      noModelPresets: 'Det finns inga förberedda arbetstidsmodeller för det här landet.',
      kindInvalid: 'Välj typ av avtal i listan.',
      modeInvalid: 'Välj vad som händer när en registrering bryter mot en regel.',
      ruleUnknown: 'Den här versionen av appen känner inte till regeln. Ladda om sidan.',
      ruleInfoOnly: 'Den här regeln visas endast som information – det går inte att avvika från den.',
    },
    // The workspace page around the section (Administration › Statutory rules):
    // a workspace without Time, and a viewer time-api does not admit.
    page: {
      timeInactiveTitle: 'Tid är inte aktivt i den här arbetsytan',
      timeInactive: 'Lagreglerna gäller arbetstiden som registreras i Tid. När Tid ingår i den här arbetsytan anger du här var ditt företag avviker från dem.',
      noAccess: 'Du kan inte hantera arbetsytans lagregler. Det kan arbetsytans ägare, suite-administratörerna och medlemmar i Tid med behörighet att hantera efterlevnad.',
    },
  },
  // Administration › Training occupations (ADR 0092).
  trainingOccupations: {
    title: 'Utbildningsyrken',
    columns: {
      occupation: 'Utbildningsyrke',
      duration: 'Längd',
      regulation: 'Utbildningsförordning',
      apprentices: 'Lärlingar',
    },
    duration: '{count} månader',
    regulationIssued: 'utfärdad {date}',
    regulationValidFrom: 'i kraft sedan {date}',
    areas: {
      IH: 'Industri och handel (IHK)',
      Hw: 'Hantverk (HWK)',
      oeD: 'Offentlig tjänst',
      Lw: 'Jordbruk',
      FB: 'Fria yrken',
      Hausw: 'Hushållsekonomi',
      See: 'Sjöfart',
    },
    branches: {
      specialisations: 'Inriktningar',
      focuses: 'Fördjupningar',
      any: 'Inriktningar / fördjupningar',
    },
    requirements: {
      onWall: 'Positioner ur utbildningsförordningen på färdighetsväggen: {count}',
      version: 'förordning utfärdad {date}',
      none: 'Positionerna ur utbildningsförordningen är inte tillgängliga ännu. De visas på färdighetsväggen så snart plattformsoperatören har importerat dem.',
      versions: 'Lärlingarna utbildas enligt {count} versioner av förordningen – för var och en gäller den version som var i kraft när utbildningen började.',
    },
    state: {
      notSelectable: 'Kan inte längre väljas',
      notSelectableHint: 'Plattformsoperatören erbjuder inte längre det här yrket för nya val. Din arbetsyta behåller det och dess lärlingar – men om du tar bort det kan det inte läggas till igen.',
      withdrawn: 'Erkännandet upphävt',
      withdrawnHint: 'Det statliga erkännandet av det här yrket har upphävts, eller så finns det inte längre i förteckningen över erkända utbildningsyrken. Pågående utbildningar slutförs; det kan inte läggas till igen.',
      unknown: 'Finns inte i katalogen',
      unknownHint: 'Den här posten skrevs in innan katalogen fanns och motsvarar inget av dess yrken. Den kan bara tas bort – lägg i stället till det passande yrket från katalogen.',
    },
    offered: {
      title: 'Vårt utbud',
      intro: 'De erkända utbildningsyrken som ditt företag utbildar i. Bara dessa kan väljas för en lärling.',
      emptyTitle: 'Inget utbildningsyrke i utbudet ännu',
      empty: 'Välj i katalogen nedan de yrken som ditt företag utbildar i. Sedan kan du tilldela dem till dina lärlingar.',
      browse: 'Välj ur katalogen',
      remove: 'Ta bort',
      removeNamed: 'Ta bort {title} ur utbudet',
    },
    catalogue: {
      title: 'Lägg till från katalogen',
      intro: 'De utbildningsyrken som är erkända i Tyskland och som din arbetsyta ännu inte erbjuder. Katalogen hålls aktuell centralt.',
      unavailableTitle: 'Katalogen kan inte nås just nu',
      unavailable: 'Ditt utbud ovan visas utifrån det som den här arbetsytan har sparat. Yrken kan läggas till igen så snart katalogen är tillbaka.',
      allOffered: 'Din arbetsyta erbjuder redan alla yrken i katalogen.',
      searchPlaceholder: 'Titel eller inriktning',
      areaLabel: 'Område',
      areaAll: 'Alla områden',
      count: 'Hittade yrken: {shown} av {total}',
      noMatches: 'Inget yrke matchar din sökning.',
      resetFilters: 'Återställ sökningen',
      showMore: 'Visa fler',
      add: 'Lägg till',
      addNamed: 'Lägg till {title} i utbudet',
    },
    removeConfirm: {
      title: 'Ta bort ”{title}” ur utbudet?',
      apprentices: 'Lärlingar som just nu är knutna till det här yrket: {count}. De behåller sitt yrke och slutför sin utbildning – det kan bara inte längre väljas för nya lärlingar.',
      final: 'När det har tagits bort kan det här yrket inte läggas till igen.',
      confirm: 'Ta bort ur utbudet',
    },
    toast: {
      added: '”{title}” ingår nu i ditt utbud',
      removed: '”{title}” erbjuds inte längre',
    },
    errors: {
      notOfferable: '”{title}” kunde inte läggas till: yrket har under tiden stängts av eller dragits tillbaka. Listan har uppdaterats.',
      catalogueUnavailable: 'Katalogen kan inte nås just nu, så inget kan läggas till. Försök igen senare.',
    },
    page: {
      moduleInactiveTitle: 'Lärlingsutbildning är inte aktivt i den här arbetsytan',
      moduleInactive: 'Utbildningsyrken erbjuds för de lärlingar som hanteras i modulen Lärlingsutbildning. När den ingår i den här arbetsytan väljer du här vilka yrken ditt företag utbildar i.',
      noAccess: 'Du kan inte hantera arbetsytans utbildningsyrken. Det kan arbetsytans ägare, suite-administratörerna och medlemmar i modulen Lärlingsutbildning med behörighet att hantera den.',
    },
  },
};
